import React, { useEffect, useMemo, useRef, useState } from "react";
import AdvanceDataTable from "../UI/Table/AdvanceDataTable";
import { ADMIN_BILLING_SUMMARY, ADMIN_TOTAL_BILLING_SUMMARY } from "../UI/Table/ColumnConst";
import EmptyImg from "../Dashboard/assets/img/create-project.png";
import ReactDatePicker from "react-datepicker";
import AdminLayout from "../UI/Layout/AdminLayout";
import Title from "../UI/Text/Title";
import Spining from "../UI/Spining/Spining";
import { userloginDetails } from "../Utils/AdminAuth";
import Select from "react-select";
import Axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { HOST_URL, HOST_URL_DB2, NODE_HOST_URL, NODE_HOST_URL_v1 } from "../Dashboard/api/Api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faCalendarAlt, faEdit, faEye, faFileExcel, faSearch, faSort, faWallet } from "@fortawesome/free-solid-svg-icons";
import { IoLogoWhatsapp } from "react-icons/io";
import { FaEnvelope, FaInfoCircle, FaSms, FaVoicemail } from "react-icons/fa";
import { MdChat } from "react-icons/md";

const AdminBillingReport = () => {
    const lStorage = userloginDetails();
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;
    const adminType = lStorage?.user?.isAdmin;
    const [alert, setAlert] = useState({
        status: false,
        bgColor: "",
        errorMessage: "",
    });
    const [isLoading, setIsLoading] = useState(false);
    const [fromdate, setFromdate] = useState("");
    const [todate, setTodate] = useState("");
    const [allusers, setAllusers] = useState([]);
    const [selecteduser, setSelectedusers] = useState("");
    const [userInputValue, setUserInputValue] = useState('');
    const [isLoadingUsers, setIsLoadingUsers] = useState(false);
    const userDebounceRef = useRef(null);
    const [billData, setBillData] = useState('');
    const [searchData, setSearchData] = useState('')
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage] = useState(50);
    const [openAccordion, setOpenAccordion] = useState(null);
    const [parentList, setParentList] = useState([])
    const [selectedParent, setSelectedParent] = useState("");
    const [email, setEmail] = useState([]);
    const [sms, setSms] = useState([]);
    const [voice, setVoice] = useState([]);
    const [whatsappApi, setWhatsappApi] = useState([]);
    const [whatsappCampaign, setWhatsappCampaign] = useState([]);
    const [agentDetails, setAgentDetails] = useState([]);
    const [agentCount, setAgentCount] = useState('')
    const [FinalData, setFinalData] = useState({
        totalSms: 0,
        totalVoice: 0,
        totalEmail: 0,
        totalWhatsapp: 0,
        totalRevenue: 0
    });
    const [totalWhatsappCost, setTotalWhatsappCost] = useState(0);
    const [whatsappConversationSummary, setWhatsappConversationSummary] = useState([]);
    const [rcs, setRcs] = useState([]);
    const [channel, setChannel] = useState("");
    const [billStatus, setBillStatus] = useState({});
    const [openKeys, setOpenKeys] = useState([]); // keep track of open accordions
    const [otp, setOtp] = useState('');
    const [enterOtp, setEnterOtp] = useState(false)
    const [countryname, setCountryname] = useState([])
    const [smsTotalCost, setSmsTotalCost] = useState({
        delivered: 0,
        failed: 0,
        other: 0,
        total: 0,
        total_cost: 0,
        total_cost_parent: 0
    });
    const [emailTotalCost, setEmailTotalCost] = useState({
        delivered: 0,
        failed: 0,
        other: 0,
        total: 0,
        total_cost: 0,
        total_cost_parent: 0
    });
    const [rcsTotalCost, setRcsTotalCost] = useState({
        text: {
            delivered: 0,
            failed: 0,
            other: 0,
            contact_count: 0,
            block_cr: 0,
            block_cr_parent: 0,
        },
        richcardstandalone: {
            delivered: 0,
            failed: 0,
            other: 0,
            contact_count: 0,
            block_cr: 0,
            block_cr_parent: 0,
        },
        richcardcarousel: {
            delivered: 0,
            failed: 0,
            other: 0,
            contact_count: 0,
            block_cr: 0,
            block_cr_parent: 0,
        }
    });
    const [voiceTotalCost, setVoiceTotalCost] = useState({
        success: 0,
        failed: 0,
        submitted: 0,
        total: 0,
        total_cost: 0,
        total_cost_parent: 0,
        total_pulse_15p: 0,
        total_pulse_30p: 0
    });
    const [whatsappTotalCost, setWhatsappTotalCost] = useState({
        Utility: {
            delivered: 0,
            failed: 0,
            other: 0,
            total: 0,
            submission_cost_parent: 0,
            submission_cost_user: 0,
        },
        Marketing: {
            delivered: 0,
            failed: 0,
            other: 0,
            total: 0,
            submission_cost_parent: 0,
            submission_cost_user: 0,
        },
        Authentication: {
            delivered: 0,
            failed: 0,
            other: 0,
            total: 0,
            submission_cost_parent: 0,
            submission_cost_user: 0,
        }
    });
    const [totalWhatsappData, setTotalWhatsappData] = useState('');
    const [sorted, setSorted] = useState(false);
    const [parentTotalAmount, setParentTotalAmount] = useState(0);
    const [inr, setInr] = useState(0);
    const [usd, setUsd] = useState(0);
    const [eur, setEur] = useState(0);
    const [showPopup, setShowPopup] = useState(false);
    const [agentDetailsShow, setAgentDetailsShow] = useState(false);
    const [metaBillingModal, setMetaBillingModal] = useState(false);
    const [metaBillingData, setMetaBillingData] = useState([]);
    const [metaBillingLoading, setMetaBillingLoading] = useState(false);
    const [metaBillingUser, setMetaBillingUser] = useState('');
    const [brandNumberModal, setBrandNumberModal] = useState(false);
    const [brandNumberList, setBrandNumberList] = useState([]);
    const [brandNumberLoading, setBrandNumberLoading] = useState(false);
    const [selectedBrandNumber, setSelectedBrandNumber] = useState('');
    const [pendingMetaUser, setPendingMetaUser] = useState(null);
    const [totalAgentData, setTotalAgentData] = useState({
        agentPrice: 0,
        agentQuantity: 0,
        agentDiscount: 0,
        baseAmount: 0,
        agentDiscountAmount: 0,
        yearlyDiscount: 0,
        couponDiscount: 0,
        totalDiscountPrice: 0,
        pricePerDay: 0
    });

    useEffect(() => {
        ParentList();
        CountryName();
        ExchangeRate();
    }, []);

    const ExchangeRate = async () => {
        let payload = {
            user_id: userId,
            created: "2025-09-09",
            method: "getRate"
        }
        try {
            const { data } = await Axios.post(
                `${NODE_HOST_URL_v1}/ExchangeRate`,
                payload,
                {
                    headers: {
                        authorization: `Bearer ${userToken}`
                    }
                }
            );
            if (data.success) {
                setInr(data.data[0].INR);
                setEur(data.data[0].EUR);
                setUsd(data.data[0].USD);
            }
        } catch (error) {
            console.log(error)
        }
    }


    const handleBillStatus = (username, newStatus) => {
        setBillStatus(prev => ({
            ...prev,
            [username]: newStatus
        }));

        if (newStatus === 'billed') {
            setEnterOtp(prev => ({
                ...prev,
                [username]: true
            }));
        } else {
            setEnterOtp(prev => ({
                ...prev,
                [username]: false
            }));
        }
    };

    const toggleAccordion = (key) => {
        setOpenKeys(prev =>
            prev.includes(key)
                ? prev.filter(k => k !== key)
                : [...prev, key]
        );
    };

    const totalActionData = (whatsappCampaign, whatsappApi) => {
        let totalWhatsappApiCost = 0;
        let totalWhatsappCampaignCost = 0;


        whatsappApi.forEach((x) => {
            totalWhatsappApiCost += parseFloat(x.total_billable_cost)
        });


        whatsappCampaign.forEach((x) => {
            totalWhatsappCampaignCost += parseFloat(x.per_wp_price) * parseFloat(x.total_delivered);
        });
        setTotalWhatsappCost(parseFloat(totalWhatsappApiCost + totalWhatsappCampaignCost))

        // If you want to return the total cost or set it elsewhere
        // setTotalWhatsappCost(totalWhatsappApiCost + totalWhatsappCampaignCost);
    }



    const totalData = (data) => {
        let totalcost = [];

        data.map((x) => {
            return (
                totalcost = x.per_wp_price * x.total_delivered
            )
        });

    }

    const customStyles = {
        control: (provided) => ({
            ...provided,
            cursor: "pointer",
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        option: (style) => ({
            ...style,
            fontSize: "12px",
        }),
    };

    const CountryName = async () => {
        try {
            let { data } = await Axios.post(`${HOST_URL}/country_master.php`)
            if (data.success) {
                setCountryname(data.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const ParentList = async () => {
        const parentParams = {
            user_id: userId,
            method: "retrieve",
            type: adminType,
            token: userToken
        }
        try {
            const { data } = await Axios.post(`${HOST_URL}/employee_user_list.php`, parentParams)
            if (data.success === true) {
                let result = data.data
                const formattedParent = result.map(user => ({
                    value: user.id,
                    label: user.email,
                    type: user.user_type
                }));
                setParentList(formattedParent);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const handleParentChange = (selectedOption) => {
        setSelectedParent(selectedOption);
        setBillData("");
        setAllusers([]);
        setSelectedusers("");
        setUserInputValue('');
        setAlert({ status: false });
    };

    const searchUsers = async (value) => {
        setIsLoadingUsers(true);
        try {
            const { data } = await Axios.post(`https://napi.authkey.io/api2/v1/admin/users/search`, {
                user_id: userId,
                token: userToken,
                method: 'search_user',
                search_value: value,
            });
            if (data.success) {
                console.log(data);
                
                setAllusers(data.data.map(u => ({ value: u.id, label: u.email })));
            } else {
                setAllusers([]);
            }
        } catch (error) {
            console.error('Error searching users:', error);
            setAllusers([]);
        } finally {
            setIsLoadingUsers(false);
        }
    };

    const handleUserInputChange = (value) => {
        setUserInputValue(value);
        if (userDebounceRef.current) clearTimeout(userDebounceRef.current);
        if (value.length >= 4) {
            userDebounceRef.current = setTimeout(() => searchUsers(value), 400);
        } else {
            setAllusers([]);
        }
    };


    const currentDate = (currentDate) => {
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, "0");
        const day = String(currentDate.getDate()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    };

    const fromdateHandler = (data) => {
        setFromdate(data);
        setAlert({ status: false });
    };

    const todateHandler = (data) => {
        setTodate(data);
        setAlert({ status: false });
    };

    const isValid = () => {
        if (!fromdate) {
            setAlert({
                status: true,
                bgColor: "alert alert-danger",
                errorMessage: "Please Select From Date",
            });
            return false
        }
        if (!todate) {
            setAlert({
                status: true,
                bgColor: "alert alert-danger",
                errorMessage: "Please Select To Date",
            });
            return false
        }
        else {
            return true
        }
    }

    // Calls the two billing APIs (admin_billing_summary + rcs_billing_report)
    // fresh, merges RCS/Agent into the billing map, and returns the
    // user-wise enriched array — the single source of truth both Submit()
    // and the Excel download read from, so the download always reflects a
    // live API call rather than possibly-stale state.
    const fetchEnrichedBillingData = async () => {
        const paramData = {
            user_id: userId,
            token: userToken,
            method: "admin_billing_summary",
            type: adminType,
            channel: channel || "all",
            parent_filter: selectedParent?.value || "all",
            user_filter: selecteduser?.value || "all",
            from_date: currentDate(fromdate),
            to_date: currentDate(todate),
        };

        const paramData2 = {
            user_id: userId,
            token: userToken,
            method: "rcs_billing_report",
            parent_filter: selectedParent?.value || "all",
            user_filter: selecteduser?.value || "all",
            from_date: currentDate(fromdate),
            to_date: currentDate(todate),
        };

        const [billingResult, rcsResult] = await Promise.allSettled([
            Axios.post(`${HOST_URL_DB2}/billing_summary.php`, paramData),
            Axios.post(`${NODE_HOST_URL}/billing_report`, paramData2),
        ]);

        /* ---------------- BILLING DATA ---------------- */
        const billingData =
            billingResult.status === "fulfilled" &&
                billingResult.value?.data?.success &&
                billingResult.value?.data?.message
                ? billingResult.value.data.message
                : {};

        const billingMap = { ...billingData };

        /* ---------------- RCS DATA ---------------- */
        const rcsDataArray =
            rcsResult.status === "fulfilled" &&
                rcsResult.value?.data?.success &&
                Array.isArray(rcsResult.value.data.data)
                ? rcsResult.value.data.data
                : [];

        /* ---------------- MERGE RCS + AGENT ---------------- */
        rcsDataArray.forEach((rcsUser) => {
            const uid = parseInt(rcsUser.user_id, 10);
            const username = rcsUser.username;
            const parentname = rcsUser.parent_username;

            /* ---------- RCS NORMALIZATION ---------- */
            const rcsObj = {};
            const rcsRawArray = Array.isArray(rcsUser.data) ? rcsUser.data : [];

            rcsRawArray.forEach((block) => {
                if (block?.submit_from) {
                    rcsObj[block.submit_from] = Array.isArray(block.data)
                        ? block.data
                        : [];
                }
            });

            /* ---------- AGENT NORMALIZATION (FIXED) ---------- */
            const agentRaw = rcsUser.agent_bill_data && typeof rcsUser.agent_bill_data === "object"
                ? rcsUser.agent_bill_data
                : {};

            const agentObj = {
                totals: {
                    total_paid_amount: agentRaw?.totals?.total_paid_amount || 0,
                    total_outstanding_amount: agentRaw?.totals?.total_outstanding_amount || 0,
                    total_bills: agentRaw?.totals?.total_bills || 0,
                },
                data: Array.isArray(agentRaw?.data) ? agentRaw.data : [],
            };

            /* ---------- MERGE INTO BILLING ---------- */
            const matchingKey = Object.keys(billingMap).find(
                (key) => parseInt(billingMap[key]?.user_id, 10) === uid
            );

            if (matchingKey) {
                billingMap[matchingKey] = {
                    ...billingMap[matchingKey],
                    rcs: rcsObj,
                    agent: agentObj,
                };
            } else {
                billingMap[username] = {
                    username,
                    parentname,
                    user_id: uid,
                    rcs: rcsObj,
                    agent: agentObj,
                };
            }
        });

        /* ---------------- FINAL TRANSFORM ---------------- */
        return Object.entries(billingMap).map(
            ([username, data]) => ({
                username,
                ...data,
                totalAmount: calculateTotalAmount(data),
            })
        );
    };

    const Submit = async () => {
        if (!isValid()) return;

        setIsLoading(true);

        try {
            const enrichedData = await fetchEnrichedBillingData();

            /* ---------------- PARENT TOTAL ---------------- */
            let totalParentAmount = 0;

            enrichedData.forEach((x) => {
                if (x.parent_currency === "USD") {
                    totalParentAmount += x.totalAmount * inr;
                } else if (x.parent_currency === "EUR") {
                    totalParentAmount += (x.totalAmount / eur) * inr;
                } else {
                    totalParentAmount += x.totalAmount;
                }
            });

            /* ---------------- STATE UPDATE ---------------- */
            setParentTotalAmount(totalParentAmount);
            setBillData(enrichedData);
            TotalCountData(enrichedData);
            TotalParentData(enrichedData);

        } catch (error) {
            console.error("❗ Unexpected error in Submit:", error);
        } finally {
            setIsLoading(false);
        }
    };



    const calculateTotalAmount = (data) => {
        let total = 0;

        const smsapi = data?.sms?.api;
        const smsCamp = data?.sms?.camp;
        const whatsappapi = data?.whatsapp?.api;
        const whatsappcamp = data?.whatsapp?.camp
        const rcspannel = data?.rcs?.PANEL
        const rcsbulkapi = data?.rcs?.BULKAPI
        const campMulti = data?.whatsapp?.camp_multi
        const userCurrency = data?.user_currency

        if (smsapi && typeof smsapi === 'object') {
            Object.keys(smsapi).forEach((apidata) => {
                if (userCurrency === "USD") {
                    total += parseFloat(smsapi[apidata].total_cost * inr || 0);
                }
                else if (userCurrency === "EUR") {
                    total += parseFloat((smsapi[apidata].total_cost / eur) * inr || 0);
                }
                else {
                    total += parseFloat(smsapi[apidata].total_cost || 0);
                }
            });
        }

        if (smsCamp && typeof smsCamp === 'object') {
            Object.keys(smsCamp).forEach((campdata) => {
                if (userCurrency === "USD") {
                    total += parseFloat(smsCamp[campdata].total_cost_user * inr || 0);
                }
                else if (userCurrency === "EUR") {
                    total += parseFloat((smsCamp[campdata].total_cost_user / eur) * inr || 0);
                }
                else {
                    total += parseFloat(smsCamp[campdata].total_cost_user || 0)
                }
            });
        }

        if (whatsappapi && typeof whatsappapi === 'object') {
            Object.keys(whatsappapi).forEach((apidata) => {
                if (userCurrency === "USD") {
                    total += parseFloat((whatsappapi[apidata]?.Utility?.submission_cost_user * inr || 0) + (whatsappapi[apidata]?.Marketing?.submission_cost_user * inr || 0) + (whatsappapi[apidata]?.Authentication?.submission_cost_user * inr || 0));
                }
                else if (userCurrency === "EUR") {
                    total += parseFloat(((whatsappapi[apidata]?.Utility?.submission_cost_user / eur) * inr || 0) + ((whatsappapi[apidata]?.Marketing?.submission_cost_user / eur) * inr || 0) + ((whatsappapi[apidata]?.Authentication?.submission_cost_user / eur) * inr || 0));
                }
                else {
                    total += parseFloat((whatsappapi[apidata]?.Utility?.submission_cost_user || 0) + (whatsappapi[apidata]?.Marketing?.submission_cost_user || 0) + (whatsappapi[apidata]?.Authentication?.submission_cost_user || 0));
                }
            });
        }

        if (whatsappcamp && typeof whatsappcamp === 'object') {
            Object.keys(whatsappcamp).forEach((campdata) => {
                if (userCurrency === "USD") {
                    total += parseFloat((whatsappcamp[campdata]?.Utility?.submission_cost_user * inr || 0) + (whatsappcamp[campdata]?.Marketing?.submission_cost_user * inr || 0) + (whatsappcamp[campdata]?.Authentication?.submission_cost_user * inr || 0));
                }
                if (userCurrency === "EUR") {
                    total += parseFloat(((whatsappcamp[campdata]?.Utility?.submission_cost_user / eur) * inr || 0) + ((whatsappcamp[campdata]?.Marketing?.submission_cost_user / eur) * inr || 0) + ((whatsappcamp[campdata]?.Authentication?.submission_cost_user / eur) * inr || 0));
                }
                else {
                    total += parseFloat((whatsappcamp[campdata]?.Utility?.submission_cost_user || 0) + (whatsappcamp[campdata]?.Marketing?.submission_cost_user || 0) + (whatsappcamp[campdata]?.Authentication?.submission_cost_user || 0))
                }
            });
        }

        if (campMulti && typeof campMulti === 'object') {
            Object.keys(campMulti).forEach((campdata) => {
                if (userCurrency === "USD") {
                    total += parseFloat((campMulti[campdata]?.Utility?.submission_cost_user * inr || 0) + (campMulti[campdata]?.Marketing?.submission_cost_user * inr || 0) + (campMulti[campdata]?.Authentication?.submission_cost_user * inr || 0));
                }
                if (userCurrency === "EUR") {
                    total += parseFloat(((campMulti[campdata]?.Utility?.submission_cost_user / eur) * inr || 0) + ((campMulti[campdata]?.Marketing?.submission_cost_user / eur) * inr || 0) + ((campMulti[campdata]?.Authentication?.submission_cost_user / eur) * inr || 0));
                }
                else {
                    total += parseFloat((campMulti[campdata]?.Utility?.submission_cost_user || 0) + (campMulti[campdata]?.Marketing?.submission_cost_user || 0) + (campMulti[campdata]?.Authentication?.submission_cost_user || 0));
                }
            });
        }

        if (Array.isArray(rcspannel)) {
            rcspannel.map((x) => {
                if (userCurrency === "USD") {
                    total += parseFloat(x.data.block_cr * inr || 0);
                }
                else if (userCurrency === "EUR") {
                    total += parseFloat((x.data.block_cr / eur) * inr || 0);
                }
                else {
                    total += parseFloat(x.data.block_cr || 0);
                }

            });
        }

        if (Array.isArray(rcsbulkapi)) {
            rcsbulkapi.map((x) => {
                if (userCurrency === "USD") {
                    total += parseFloat(x.data.block_cr * inr || 0);
                }
                else if (userCurrency === "EUR") {
                    total += parseFloat((x.data.block_cr / eur) * inr || 0);
                }
                else {
                    total += parseFloat(x.data.block_cr || 0);
                }

            });
        }

        const voice = data?.voice?.api
        if (userCurrency === "USD") {
            total += parseFloat(voice?.total_cost * inr || 0)
        }
        else if (userCurrency === "EUR") {
            total += parseFloat((voice?.total_cost / eur) * inr || 0)
        }
        else {
            total += parseFloat(voice?.total_cost || 0)
        }

        const email = data?.email?.api
        if (userCurrency === "USD") {
            total += parseFloat(email?.total_cost * inr || 0)
        }
        else if (userCurrency === "EUR") {
            total += parseFloat((email?.total_cost / eur) * inr || 0)
        }
        else {
            total += parseFloat(email?.total_cost || 0)
        }


        return total;
    };



    const handleSort = () => {
        const updatedData = billData.map((item) => {
            const totalAmount = calculateTotalAmount(item);
            return {
                ...item,
                totalAmount, // attach freshly calculated amount
            };
        });

        const sortedData = updatedData.sort((a, b) =>
            sorted ? a.totalAmount - b.totalAmount : b.totalAmount - a.totalAmount
        );
        setBillData(sortedData);
        setSorted(!sorted);
    };



    const TotalParentData = (data) => {
        // console.log(data);


        // ================= SMS =================
        let smsapi = {
            delivered: 0, failed: 0, other: 0, total: 0,
            total_cost: 0, total_cost_parent: 0
        };

        let smsCamp = {
            delivered: 0, failed: 0, other: 0, total: 0,
            total_cost: 0, total_cost_parent: 0
        };

        // ================= WHATSAPP (COUNTRY BASED) =================
        let whatsappByCountry = {};

        const initWhatsAppType = () => ({
            Utility: { total: 0, delivered: 0, failed: 0, other: 0, submission_cost_parent: 0, submission_cost_user: 0 },
            Marketing: { total: 0, delivered: 0, failed: 0, other: 0, submission_cost_parent: 0, submission_cost_user: 0 },
            Authentication: { total: 0, delivered: 0, failed: 0, other: 0, submission_cost_parent: 0, submission_cost_user: 0 },
        });

        // ================= EMAIL =================
        let emailApi = {
            delivered: 0, failed: 0, other: 0, total: 0,
            total_cost: 0, total_cost_parent: 0
        };

        // ================= VOICE =================
        let voiceApi = {
            success: 0, failed: 0, submitted: 0, total: 0,
            total_cost: 0, total_cost_parent: 0,
            total_pulse_15p: 0, total_pulse_30p: 0
        };

        // ================= RCS =================
        let rcsApi = {
            text: { contact_count: 0, delivered: 0, failed: 0, other: 0, block_cr_parent: 0, block_cr: 0 },
            richcardstandalone: { contact_count: 0, delivered: 0, failed: 0, other: 0, block_cr_parent: 0, block_cr: 0 },
            richcardcarousel: { contact_count: 0, delivered: 0, failed: 0, other: 0, block_cr_parent: 0, block_cr: 0 },
        };

        let rcsPannel = JSON.parse(JSON.stringify(rcsApi));

        // console.log(rcsPannel);


        // ================= LOOP DATA =================
        Object.keys(data || {}).forEach((itemKey) => {
            const item = data[itemKey];

            // ---------- SMS API ----------
            const smsApiData = item?.sms?.api;
            if (smsApiData && typeof smsApiData === "object") {
                Object.values(smsApiData).forEach((sms) => {
                    smsapi.delivered += parseFloat(sms?.delivered) || 0;
                    smsapi.failed += parseFloat(sms?.failed) || 0;
                    smsapi.other += parseFloat(sms?.other) || 0;
                    smsapi.total += parseFloat(sms?.total) || 0;
                    smsapi.total_cost += parseFloat(sms?.total_cost) || 0;
                    smsapi.total_cost_parent += parseFloat(sms?.total_cost_parent) || 0;
                });
            }

            // ---------- SMS CAMP ----------
            const smsCampData = item?.sms?.camp;
            if (smsCampData && typeof smsCampData === "object") {
                Object.values(smsCampData).forEach((sms) => {
                    smsCamp.delivered += parseFloat(sms?.delivered) || 0;
                    smsCamp.failed += parseFloat(sms?.failed) || 0;
                    smsCamp.other += parseFloat(sms?.other) || 0;
                    smsCamp.total += parseFloat(sms?.total) || 0;
                    smsCamp.total_cost += parseFloat(sms?.total_cost_user) || 0;
                    smsCamp.total_cost_parent += parseFloat(sms?.total_cost_parent) || 0;
                });
            }

            // ---------- WHATSAPP API (COUNTRY CODE) ----------
            const waApiData = item?.whatsapp?.api;


            if (waApiData && typeof waApiData === "object") {
                Object.entries(waApiData).forEach(([countryCode, wa]) => {

                    if (!whatsappByCountry[countryCode]) {
                        whatsappByCountry[countryCode] = initWhatsAppType();
                    }

                    ["Utility", "Marketing", "Authentication"].forEach((type) => {

                        const typeData = wa?.[type];
                        if (!typeData) return; // <<< IMPORTANT FIX

                        whatsappByCountry[countryCode][type].delivered += parseFloat(typeData.delivered) || 0;
                        whatsappByCountry[countryCode][type].failed += parseFloat(typeData.failed) || 0;
                        whatsappByCountry[countryCode][type].other += parseFloat(typeData.other) || 0;
                        whatsappByCountry[countryCode][type].total += parseFloat(typeData.total) || 0;
                        whatsappByCountry[countryCode][type].submission_cost_parent += parseFloat(typeData.submission_cost_parent) || 0;
                        whatsappByCountry[countryCode][type].submission_cost_user += parseFloat(typeData.submission_cost_user) || 0;
                    });

                });

            }

            // ---------- WHATSAPP CAMP MULTI ----------
            const waCampDataMulti = item?.whatsapp?.camp_multi;

            if (waCampDataMulti && typeof waCampDataMulti === "object") {
                Object.entries(waCampDataMulti).forEach(([countryCode, wa]) => {

                    if (!whatsappByCountry[countryCode]) {
                        whatsappByCountry[countryCode] = initWhatsAppType();
                    }

                    ["Utility", "Marketing", "Authentication"].forEach((type) => {

                        const typeData = wa?.[type];
                        if (!typeData) return; // <<< FIX

                        whatsappByCountry[countryCode][type].delivered += parseFloat(typeData.delivered) || 0;
                        whatsappByCountry[countryCode][type].failed += parseFloat(typeData.failed) || 0;
                        whatsappByCountry[countryCode][type].other += parseFloat(typeData.other) || 0;
                        whatsappByCountry[countryCode][type].total += parseFloat(typeData.total) || 0;
                        whatsappByCountry[countryCode][type].submission_cost_parent += parseFloat(typeData.submission_cost_parent) || 0;
                        whatsappByCountry[countryCode][type].submission_cost_user += parseFloat(typeData.submission_cost_user) || 0;
                    });

                });

            }

            const waCampData = item?.whatsapp?.camp;

            if (waCampData && typeof waCampData === "object") {
                Object.entries(waCampData).forEach(([countryCode, wa]) => {

                    if (!whatsappByCountry[countryCode]) {
                        whatsappByCountry[countryCode] = initWhatsAppType();
                    }

                    ["Utility", "Marketing", "Authentication"].forEach((type) => {

                        const typeData = wa?.[type];
                        if (!typeData) return; // <<< FIX

                        whatsappByCountry[countryCode][type].delivered += parseFloat(typeData.delivered) || 0;
                        whatsappByCountry[countryCode][type].failed += parseFloat(typeData.failed) || 0;
                        whatsappByCountry[countryCode][type].other += parseFloat(typeData.other) || 0;
                        whatsappByCountry[countryCode][type].total += parseFloat(typeData.total) || 0;
                        whatsappByCountry[countryCode][type].submission_cost_parent += parseFloat(typeData.submission_cost_parent) || 0;
                        whatsappByCountry[countryCode][type].submission_cost_user += parseFloat(typeData.submission_cost_user) || 0;
                    });

                });

            }


            // ---------- EMAIL ----------
            const emailApiData = item?.email?.api;
            if (emailApiData) {
                emailApi.delivered += parseFloat(emailApiData?.delivered) || 0;
                emailApi.failed += parseFloat(emailApiData?.failed) || 0;
                emailApi.other += parseFloat(emailApiData?.other) || 0;
                emailApi.total += parseFloat(emailApiData?.total) || 0;
                emailApi.total_cost += parseFloat(emailApiData?.total_cost) || 0;
                emailApi.total_cost_parent += parseFloat(emailApiData?.total_cost_parent) || 0;
            }

            // ---------- VOICE ----------
            const voiceApiData = item?.voice?.api;
            if (voiceApiData) {
                voiceApi.success += parseFloat(voiceApiData?.success) || 0;
                voiceApi.failed += parseFloat(voiceApiData?.failed) || 0;
                voiceApi.submitted += parseFloat(voiceApiData?.submitted) || 0;
                voiceApi.total += parseFloat(voiceApiData?.total) || 0;
                voiceApi.total_cost += parseFloat(voiceApiData?.total_cost) || 0;
                voiceApi.total_cost_parent += parseFloat(voiceApiData?.total_cost_parent) || 0;
                voiceApi.total_pulse_15p += parseFloat(voiceApiData?.total_pulse_15p) || 0;
                voiceApi.total_pulse_30p += parseFloat(voiceApiData?.total_pulse_30p) || 0;
            }

            // ---------- RCS ----------
            const rcsData = item?.rcs?.PANEL;
            const rcsApiData = item?.rcs?.BULKAPI;

            const updateRcs = (target, x) => {
                const type = x?.rcs_type;
                if (!target[type]) return;

                target[type].contact_count += x?.data?.contact_count || 0;
                target[type].delivered += x?.data?.deliver_count || 0;
                target[type].failed += x?.data?.fail_count || 0;
                target[type].other += x?.data?.other_count || 0;
                target[type].block_cr += x?.data?.block_cr || 0;
                target[type].block_cr_parent += x?.data?.block_cr_parent || 0;
            };

            Array.isArray(rcsData) && rcsData.forEach(x => updateRcs(rcsPannel, x));
            Array.isArray(rcsApiData) && rcsApiData.forEach(x => updateRcs(rcsApi, x));
        });

        // ================= SET STATE =================

        setSmsTotalCost({
            delivered: smsapi.delivered + smsCamp.delivered,
            failed: smsapi.failed + smsCamp.failed,
            other: smsapi.other + smsCamp.other,
            total: smsapi.total + smsCamp.total,
            total_cost: smsapi.total_cost + smsCamp.total_cost,
            total_cost_parent: smsapi.total_cost_parent + smsCamp.total_cost_parent
        });

        setEmailTotalCost(emailApi);

        setVoiceTotalCost(voiceApi);

        setRcsTotalCost({
            text: {
                delivered: rcsPannel.text.delivered + rcsApi.text.delivered,
                failed: rcsPannel.text.failed + rcsApi.text.failed,
                other: rcsPannel.text.other + rcsApi.text.other,
                contact_count: rcsPannel.text.contact_count + rcsApi.text.contact_count,
                block_cr: rcsPannel.text.block_cr + rcsApi.text.block_cr,
                block_cr_parent: rcsPannel.text.block_cr_parent + rcsApi.text.block_cr_parent,
            },
            richcardstandalone: {
                delivered: rcsPannel.richcardstandalone.delivered + rcsApi.richcardstandalone.delivered,
                failed: rcsPannel.richcardstandalone.failed + rcsApi.richcardstandalone.failed,
                other: rcsPannel.richcardstandalone.other + rcsApi.richcardstandalone.other,
                contact_count: rcsPannel.richcardstandalone.contact_count + rcsApi.richcardstandalone.contact_count,
                block_cr: rcsPannel.richcardstandalone.block_cr + rcsApi.richcardstandalone.block_cr,
                block_cr_parent: rcsPannel.richcardstandalone.block_cr_parent + rcsApi.richcardstandalone.block_cr_parent,
            },
            richcardcarousel: {
                delivered: rcsPannel.richcardcarousel.delivered + rcsApi.richcardcarousel.delivered,
                failed: rcsPannel.richcardcarousel.failed + rcsApi.richcardcarousel.failed,
                other: rcsPannel.richcardcarousel.other + rcsApi.richcardcarousel.other,
                contact_count: rcsPannel.richcardcarousel.contact_count + rcsApi.richcardcarousel.contact_count,
                block_cr: rcsPannel.richcardcarousel.block_cr + rcsApi.richcardcarousel.block_cr,
                block_cr_parent: rcsPannel.richcardcarousel.block_cr_parent + rcsApi.richcardcarousel.block_cr_parent,
            }
        });

        // FINAL WHATSAPP COUNTRY-WISE DATA
        setWhatsappTotalCost(whatsappByCountry);
        getOverallTotals(whatsappByCountry)
    };


    const TotalCountData = (data) => {
        let totalSms = 0;
        let totalVoice = 0;
        let totalEmail = 0;
        let totalWhatsapp = 0;
        let totalRevenue = 0;

        // data.forEach((x) => {
        //     totalSms += parseFloat(x.total_sms_summary) || 0;
        //     totalVoice += parseFloat(x.total_voice_summary) || 0;
        //     totalEmail += parseFloat(x.total_email_summary) || 0;
        //     totalWhatsapp += parseFloat(x.grand_total_summary) || 0;
        //     totalRevenue += parseFloat(x.total_sms_summary + x.total_voice_summary + x.total_email_summary + x.grand_total_summary)
        // });

        setFinalData({
            totalSms: totalSms,
            totalVoice: totalVoice,
            totalEmail: totalEmail,
            totalWhatsapp: totalWhatsapp,
            totalRevenue: totalRevenue
        });
    };

    const today = new Date();

    // 2 days before today
    const cutoffDate = new Date(today);
    cutoffDate.setDate(today.getDate() - 2);

    const filterToDate = (date) => {
        if (!fromdate) return false; // Disable everything until fromdate selected

        const selectedMonth = fromdate.getMonth();
        const selectedYear = fromdate.getFullYear();

        return (
            date.getMonth() === selectedMonth &&
            date.getFullYear() === selectedYear
        );
    };


    // const allowedMonth = cutoffDate.getMonth();
    // const allowedYear = cutoffDate.getFullYear();

    // // Enable only the month of cutoffDate
    // const filterAllowedDates = (date) => {
    //     return date.getMonth() === allowedMonth && date.getFullYear() === allowedYear;
    // };



    const usersArray = Object.entries(billData).map(([email, details]) => ({
        email,
        ...details
    }));

    // Filter first, then paginate — the accordion per-row breakdown below is
    // expensive to compute/render, so only the current page's keys get mapped.
    const filteredBillKeys = useMemo(() => {
        return Object.keys(billData).filter((key) => {
            if (searchData.trim() === '') return true;
            const lowerSearch = searchData.toLowerCase();
            return (
                billData[key]?.username?.toLowerCase().includes(lowerSearch) ||
                billData[key]?.parent_biling_type?.toLowerCase().includes(lowerSearch)
            );
        });
    }, [billData, searchData]);

    const totalBillPages = Math.max(1, Math.ceil(filteredBillKeys.length / recordsPerPage));

    const paginatedBillKeys = useMemo(
        () => filteredBillKeys.slice((currentPage - 1) * recordsPerPage, currentPage * recordsPerPage),
        [filteredBillKeys, currentPage, recordsPerPage]
    );

    useEffect(() => {
        setCurrentPage(1);
    }, [searchData, billData]);

    const handleChannelChange = (e) => {
        setChannel(e.target.value)
        setBillData([]);
    }

    const handleUserChange = (selectedOption) => {
        setSelectedusers(selectedOption);
        setBillData("")
    }

    const Months = [
        { value: 1, label: "January" },
        { value: 2, label: "February" },
        { value: 3, label: "March" },
        { value: 4, label: "April" },
        { value: 5, label: "May" },
        { value: 6, label: "June" },
        { value: 7, label: "July" },
        { value: 8, label: "August" },
        { value: 9, label: "September" },
        { value: 10, label: "October" },
        { value: 11, label: "November" },
        { value: 12, label: "December" },
    ]

    const RechargeAmount = async (items) => {
        const dueId = items
            .filter(x => x.status === "paid")
            .map(x => x._id);

        let paramData = {
            user_id: userId,
            token: userToken,
            method: "agent_manual_bill_pay",
            bill_ids: dueId
        }
        let { data } = await Axios.post(`${NODE_HOST_URL}/billing_report`, paramData)
        if (data.success) {
            // console.log(data);
        }
    };

    const RechargeByID = async (id) => {
        let paramData = {
            user_id: userId,
            token: userToken,
            method: "agent_manual_bill_pay",
            bill_ids: [`${id}`]
        }

        let { data } = await Axios.post(`${NODE_HOST_URL}/billing_report`, paramData)
        if (data.success) {
            // console.log(data);
        }
    }

    const agentInnerDetails = (data) => {
        console.log(data)
        setAgentDetailsShow(true);

        let totalPrice = 0;

        const baseAmount = data.agent_price * data.agent_quantity;
        const agentDiscountAmount = (baseAmount * data.agent_discount) / 100;

        if (data.billing_type === "monthly") {

            if (data.pay_days === null) {

                totalPrice =
                    baseAmount -
                    agentDiscountAmount

            } else {

                const monthlyAfterDiscount =
                    baseAmount -
                    agentDiscountAmount

                totalPrice = (monthlyAfterDiscount / 30) * data.pay_days;
            }
        } else {

            if (data.pay_days === null) {

                totalPrice =
                    baseAmount -
                    agentDiscountAmount

            } else {

                const monthlyAfterDiscount =
                    baseAmount -
                    agentDiscountAmount


                totalPrice = (monthlyAfterDiscount / 365) * data.pay_days;
            }
        }

        const totalDiscountPrice = totalPrice - data.yearly_discount - data.coupon_discount;

        setTotalAgentData({
            agentPrice: data.agent_price,
            agentQuantity: data.agent_quantity,
            agentDiscount: data.agent_discount,
            baseAmount: baseAmount,
            agentDiscountAmount: agentDiscountAmount,
            yearlyDiscount: data.yearly_discount,
            couponDiscount: data.coupon_discount,
            totalDiscountPrice: totalDiscountPrice,
            pricePerDay: data.pay_days
        })

        // console.log("Total Price:", totalDiscountPrice);
    };

    const fetchMetaBilling = async (reqUserId, username, brandNumber) => {
        setMetaBillingModal(true);
        setMetaBillingLoading(true);
        setMetaBillingData([]);
        setMetaBillingUser(username);
        try {
            const { data } = await Axios.post(`https://napi.authkey.io/api2/v1/admin/whatsapp`, {
                user_id: userId,
                token: userToken,
                method: "get_billing_details",
                req_user_id: reqUserId,
                brand_number: brandNumber,
                from_date: currentDate(fromdate),
                to_date: currentDate(todate),
            });
            if (data.success) {
                console.log(data);

                setMetaBillingData(data.data.analytics.data_points || []);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setMetaBillingLoading(false);
        }
    };

    // console.log(metaBillingData);

    const openBrandNumberModal = async (reqUserId, username) => {
        setPendingMetaUser({ reqUserId, username });
        setSelectedBrandNumber('');
        setBrandNumberList([]);
        setBrandNumberModal(true);
        setBrandNumberLoading(true);
        try {
            const { data } = await Axios.post(`https://napi.authkey.io/api2/v1/admin/whatsapp`, {
                user_id: userId,
                token: userToken,
                method: "get_brand_number",
                req_user_id: reqUserId,
            });
            if (data.success) {
                setBrandNumberList(data.message || []);
                if ((data.message || []).length) {
                    setSelectedBrandNumber(data.message[0].brand_number);
                }
            } else {
                setBrandNumberList([]);
            }
        } catch (err) {
            console.error(err);
            setBrandNumberList([]);
        } finally {
            setBrandNumberLoading(false);
        }
    };

    const handleBrandNumberContinue = () => {
        if (!pendingMetaUser || !selectedBrandNumber) return;
        setBrandNumberModal(false);
        fetchMetaBilling(pendingMetaUser.reqUserId, pendingMetaUser.username, selectedBrandNumber);
    };

    // Builds the same per-channel rows shown in a user's accordion
    // ("Detail Report": WhatsApp/Conversation/SMS/RCS/Voice/Email), from the
    // raw pieces of that user's billData record — used to flatten every
    // user into one combined export.
    const buildDetailReportRows = (d) => {
        const rows = [];
        const waMode = d.modeFlags.whatsappbm === "1" || d.modeFlags.whatsappbm === 1 ? "Delivery" : "Submission";
        const smsMode = d.modeFlags.smsbm === "1" || d.modeFlags.smsbm === 1 ? "Delivery" : "Submission";
        const rcsMode = d.modeFlags.rcsbm === "1" || d.modeFlags.rcsbm === 1 ? "Delivery" : "Submission";
        const voiceMode = d.modeFlags.voicebm === "1" || d.modeFlags.voicebm === 1 ? "Delivery" : "Submission";
        const emailMode = d.modeFlags.emailbm === "1" || d.modeFlags.emailbm === 1 ? "Delivery" : "Submission";

        const countryLabel = (cc) => `${cc} (${countryname.find(c => String(c.country_code) === String(cc))?.country_name || "-"})`;

        // ---------- WhatsApp (per country / category) ----------
        const waSourceEntries = Object.entries(d.whatsappData || {}).filter(([k]) => k !== "conv");
        const waCountryCodes = Array.from(new Set(waSourceEntries.flatMap(([, src]) => Object.keys(src || {}))));

        waCountryCodes.forEach(cc => {
            const perSource = waSourceEntries.map(([, src]) => src?.[cc] || {});
            ["Utility", "Marketing", "Authentication"].forEach(cat => {
                if (!perSource.some(s => s?.[cat])) return;
                const combined = perSource.map(s => s?.[cat] || {});

                const total = combined.reduce((s, i) => s + (parseInt(i.total) || 0), 0);
                const delivered = combined.reduce((s, i) => s + (parseInt(i.delivered) || 0), 0);
                const failed = combined.reduce((s, i) => s + (parseInt(i.failed) || 0), 0);
                const other = combined.reduce((s, i) => s + (parseInt(i.other) || 0), 0);
                const sentCount = combined.reduce((s, i) => s + (parseInt(i.sent_count) || 0), 0);
                const price = parseFloat(combined.find(i => i.per_wp_cost)?.per_wp_cost ?? 0).toFixed(6);
                const userCost = combined.reduce((s, i) => s + (parseFloat(i.submission_cost_user) || 0), 0).toFixed(6);
                const parentCost = combined.reduce((s, i) => s + (parseFloat(i.submission_cost_parent) || 0), 0).toFixed(6);

                rows.push({
                    Channel: `WhatsApp (${waMode})`, Category: cat, CountryCode: countryLabel(cc),
                    Total: total, Delivered: delivered, Failed: failed, Other: other,
                    "Sent Count": sentCount, "User Pulse (Voice)": "-",
                    Price: price, "User Cost": userCost, "Parent Cost": parentCost,
                });
            });
        });

        // ---------- WhatsApp Conversation ----------
        if (d.conversation && typeof d.conversation === "object") {
            Object.entries(d.conversation).forEach(([key, value]) => {
                rows.push({
                    Channel: "WhatsApp Conversation", Category: key, CountryCode: "-",
                    Total: "-", Delivered: "-", Failed: "-", Other: "-",
                    "Sent Count": "-", "User Pulse (Voice)": "-",
                    Price: value, "User Cost": "-", "Parent Cost": "-",
                });
            });
        }

        // ---------- SMS (per country) ----------
        const smsApiCountries = Object.keys(d.sms?.api || {});
        const smsCampCountries = Object.keys(d.sms?.camp || {});
        const smsCountryCodes = Array.from(new Set([...smsApiCountries, ...smsCampCountries]));

        smsCountryCodes.forEach(cc => {
            const apiData = d.sms?.api?.[cc] || {};
            const campData = d.sms?.camp?.[cc] || {};

            const total = (parseInt(apiData.total) || 0) + (parseInt(campData.total) || 0);
            const delivered = (parseInt(apiData.delivered) || 0) + (parseInt(campData.delivered) || 0);
            const sentCount = (parseInt(apiData.sent_count) || 0) + (parseInt(campData.sent_count) || 0);
            const failed = (parseInt(apiData.failed) || 0) + (parseInt(campData.failed) || 0);
            const other = (parseInt(apiData.other) || 0) + (parseInt(campData.other) || 0);
            const perSmsCost = parseFloat(apiData.per_sms_cost ?? campData.per_sms_cost ?? 0).toFixed(6);
            const totalCost = ((parseFloat(apiData.total_cost || apiData.total_cost_user) || 0) + (parseFloat(campData.total_cost || campData.total_cost_user) || 0)).toFixed(6);
            const totalCostParent = ((parseFloat(apiData.total_cost_parent) || 0) + (parseFloat(campData.total_cost_parent) || 0)).toFixed(6);

            rows.push({
                Channel: `SMS (${smsMode})`, Category: "-",
                CountryCode: cc === "9999" ? "(multiple)" : countryLabel(cc),
                Total: total, Delivered: delivered, Failed: failed, Other: other,
                "Sent Count": "-", "User Pulse (Voice)": "-",
                Price: perSmsCost, "User Cost": totalCost, "Parent Cost": totalCostParent,
            });
        });

        // ---------- RCS (Text / RichCardStandAlone / RichCardCarousel) ----------
        const rcsRows = [
            {
                Category: "Text",
                Total: (d.rcsTextData.contact_count || 0) + (d.rcsTextBulkData.contact_count || 0),
                Delivered: (d.rcsTextData.deliver_count || 0) + (d.rcsTextBulkData.deliver_count || 0),
                Failed: (d.rcsTextData.fail_count || 0) + (d.rcsTextBulkData.fail_count || 0),
                Other: (d.rcsTextData.other_count || 0) + (d.rcsTextBulkData.other_count || 0),
                "User Cost": (d.rcsTextData.block_cr || 0) + (d.rcsTextBulkData.block_cr || 0),
                "Parent Cost": (d.rcsTextData.block_cr_parent || 0) + (d.rcsTextBulkData.block_cr_parent || 0),
            },
            {
                Category: "RichCardStandAlone",
                Total: (d.rcsRichCardData.contact_count || 0) + (d.rcsRichCardBulkData.contact_count || 0),
                Delivered: (d.rcsRichCardData.deliver_count || 0) + (d.rcsRichCardBulkData.deliver_count || 0),
                Failed: (d.rcsRichCardData.fail_count || 0) + (d.rcsRichCardBulkData.fail_count || 0),
                Other: (d.rcsRichCardData.other_count || 0) + (d.rcsRichCardBulkData.other_count || 0),
                "User Cost": (d.rcsRichCardData.block_cr || 0) + (d.rcsRichCardBulkData.block_cr || 0),
                "Parent Cost": (d.rcsRichCardData.block_cr_parent || 0) + (d.rcsRichCardBulkData.block_cr_parent || 0),
            },
            {
                Category: "RichCardCarousel",
                Total: (d.rcsCarouselData.contact_count || 0) + (d.rcsCarouselBulkData.contact_count || 0),
                Delivered: (d.rcsCarouselData.deliver_count || 0) + (d.rcsCarouselBulkData.contact_count || 0),
                Failed: (d.rcsCarouselData.fail_count || 0) + (d.rcsCarouselBulkData.contact_count || 0),
                Other: (d.rcsCarouselData.other_count || 0) + (d.rcsCarouselBulkData.contact_count || 0),
                "User Cost": (d.rcsCarouselData.block_cr || 0) + (d.rcsCarouselBulkData.contact_count || 0),
                "Parent Cost": (d.rcsCarouselData.block_cr_parent || 0) + (d.rcsCarouselBulkData.contact_count || 0),
            },
        ];
        rcsRows.forEach(r => {
            rows.push({
                Channel: `RCS (${rcsMode})`, Category: r.Category, CountryCode: "91 (India)",
                Total: r.Total, Delivered: r.Delivered, Failed: r.Failed, Other: r.Other,
                "Sent Count": "-", "User Pulse (Voice)": "-",
                Price: "-", "User Cost": r["User Cost"], "Parent Cost": r["Parent Cost"],
            });
        });

        // ---------- Voice ----------
        if (d.voice) {
            rows.push({
                Channel: `Voice (${voiceMode})`, Category: "-", CountryCode: "91 (India)",
                Total: d.voice?.total || 0, Delivered: d.voice?.success || 0,
                Failed: d.voice?.failed || 0, Other: d.voice?.submitted || 0,
                "Sent Count": "-",
                "User Pulse (Voice)": d.voice?.user_pulse === "15" ? d.voice?.total_pulse_15p : d.voice?.user_pulse === "30" ? d.voice?.total_pulse_30p : 0,
                Price: "-", "User Cost": parseFloat(d.voice?.total_cost || 0).toFixed(6), "Parent Cost": parseFloat(d.voice?.total_cost_parent || 0).toFixed(6),
            });
        }

        // ---------- Email ----------
        if (d.email) {
            rows.push({
                Channel: `Email (${emailMode})`, Category: "-", CountryCode: "91 (India)",
                Total: d.email?.total || 0, Delivered: d.email?.delivered || 0,
                Failed: d.email?.failed || 0, Other: d.email?.other || 0,
                "Sent Count": "-", "User Pulse (Voice)": "-",
                Price: parseFloat(d.email?.per_email_cost || 0).toFixed(6),
                "User Cost": parseFloat(d.email?.total_cost || 0).toFixed(6), "Parent Cost": parseFloat(d.email?.total_cost_parent || 0).toFixed(6),
            });
        }

        return rows;
    };

    const buildAgentReportRows = (agentBillingData, agentBillingTotalData) => {
        if (!agentBillingData || agentBillingData.length === 0) return [];
        return agentBillingData.map(item => ({
            Channel: "Agent",
            "Total Paid Amount": parseFloat(agentBillingTotalData?.total_paid_amount || 0).toFixed(6),
            "Total Outstanding Amount": agentBillingTotalData?.total_outstanding_amount || 0,
            "Total Bills": agentBillingTotalData?.total_bills || 0,
            "Billing Type": item.billing_type,
            "Bill Year": item.bill_year,
            "Bill Month": Months.find(m => m.value === item.bill_month)?.label || item.bill_month,
            "Paid Amount": parseFloat(item.paid_amount || 0).toFixed(6),
            "Paid Through": item.paid_through,
            "Outstanding Amount": item.outstanding_amount,
            Status: item.status,
            "Paid Date": item.paid_date,
            "Created At": item.createdAt,
        }));
    };

    // Splits a user's `rcs.PANEL` / `rcs.BULKAPI` arrays (each entry tagged
    // with rcs_type) into the three fixed RCS categories.
    const splitRcsByType = (rcsArray) => {
        const result = { text: {}, richcardstandalone: {}, richcardcarousel: {} };
        if (Array.isArray(rcsArray)) {
            rcsArray.forEach(item => {
                const dataItem = Array.isArray(item) ? item[0] : item;
                if (!dataItem) return;
                if (dataItem.rcs_type === "text") result.text = dataItem.data || {};
                else if (dataItem.rcs_type === "richcardstandalone") result.richcardstandalone = dataItem.data || {};
                else if (dataItem.rcs_type === "richcardcarousel") result.richcardcarousel = dataItem.data || {};
            });
        }
        return result;
    };

    // Downloads ONE workbook covering every user currently loaded in
    // billData (from admin_billing_summary + rcs_billing_report), user-wise —
    // a Summary row per user, plus every channel-level Detail/Agent row
    // tagged with that user's username.
    const downloadAllBillingExcel = () => {
        const summaryRows = [];
        const detailRows = [];
        const agentRows = [];

        Object.keys(billData).forEach((key) => {
            const record = billData[key];
            if (!record || !record.username) return;

            const username = record.username;

            summaryRows.push({
                Username: username,
                "Parent Username": record.parent || record.parentname || "-",
                "Billing Type": record.parent_biling_type || "-",
                "User Billing Type": record.user_biling_type || "Prepaid",
                "Auto Refund": record.auto_refund || "NO",
                "Total Amount": parseFloat(record.totalAmount || 0).toFixed(6),
                Currency: record.user_currency || "-",
            });

            const rcsPannelByType = splitRcsByType(record?.rcs?.PANEL);
            const rcsBulkApiByType = splitRcsByType(record?.rcs?.BULKAPI);

            const userDetailRows = buildDetailReportRows({
                whatsappData: record?.whatsapp,
                conversation: record?.whatsapp?.conv?.sms_cost,
                sms: record?.sms,
                voice: record?.voice?.api,
                email: record?.email?.api,
                rcsTextData: rcsPannelByType.text,
                rcsRichCardData: rcsPannelByType.richcardstandalone,
                rcsCarouselData: rcsPannelByType.richcardcarousel,
                rcsTextBulkData: rcsBulkApiByType.text,
                rcsRichCardBulkData: rcsBulkApiByType.richcardstandalone,
                rcsCarouselBulkData: rcsBulkApiByType.richcardcarousel,
                modeFlags: {
                    whatsappbm: record.whatsappbm,
                    smsbm: record.smsbm,
                    rcsbm: record.rcsbm,
                    voicebm: record.voicebm,
                    emailbm: record.emailbm,
                },
            });
            userDetailRows.forEach(r => detailRows.push({ Username: username, ...r }));

            buildAgentReportRows(record?.agent?.data, record?.agent?.totals)
                .forEach(r => agentRows.push({ Username: username, ...r }));
        });

        if (summaryRows.length === 0) return;

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(summaryRows), "Summary");
        XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(detailRows.length ? detailRows : [{ Note: "No detail data" }]), "Detail Report");
        XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(agentRows.length ? agentRows : [{ Note: "No agent data" }]), "Agent Report");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const fileData = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(fileData, `Billing_Report_${currentDate(fromdate)}_to_${currentDate(todate)}.xlsx`);
    };

    const getOverallTotals = (data) => {
        let result = {
            total: 0,
            delivered: 0,
        };

        Object.values(data).forEach((item) => {
            ["Utility", "Marketing", "Authentication"].forEach((type) => {
                result.total += item?.[type]?.total || 0;
                result.delivered += item?.[type]?.delivered || 0;
            });
        });

        setTotalWhatsappData(result)
    };

    return (
        <div>
            <AdminLayout>
                <Title isButton={false}> Billing Report </Title>
                {Object.keys(billData).length > 0 && (
                    <div className="container my-3">
                        <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 g-4 justify-content-center">

                            {/* WhatsApp */}
                            <div className="col mb-2">
                                <div className="card shadow-sm border-0 h-100" style={{ minHeight: "150px" }}>
                                    <div className="card-body text-center">
                                        <IoLogoWhatsapp style={{ fontSize: "1.9em", color: "#25D366" }} className="mb-2" />
                                        <h5 className="card-title mb-1">WhatsApp</h5>
                                        <div className="d-flex justify-content-between mt-3">
                                            <div>
                                                <p className="mb-1 text-muted small">Total</p>
                                                <h6 className="mb-0">
                                                    {totalWhatsappData.total}
                                                </h6>
                                            </div>
                                            <div>
                                                <p className="mb-1 text-muted small">Delivered</p>
                                                <h6 className="mb-0">
                                                    {totalWhatsappData.delivered}
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* SMS */}
                            <div className="col mb-2">
                                <div className="card shadow-sm border-0 h-100" style={{ minHeight: "150px" }}>
                                    <div className="card-body text-center">
                                        <FaSms style={{ fontSize: "1.9em", color: "#007bff" }} className="mb-2" />
                                        <h5 className="card-title mb-1">SMS</h5>
                                        <div className="d-flex justify-content-between mt-3">
                                            <div>
                                                <p className="mb-1 text-muted small">Total</p>
                                                <h6 className="mb-0">{smsTotalCost.total}</h6>
                                            </div>
                                            <div>
                                                <p className="mb-1 text-muted small">Delivered</p>
                                                <h6 className="mb-0">{smsTotalCost.delivered}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* RCS */}
                            <div className="col mb-2">
                                <div className="card shadow-sm border-0 h-100" style={{ minHeight: "150px" }}>
                                    <div className="card-body text-center">
                                        <MdChat style={{ fontSize: "1.9em", color: "#17a2b8" }} className="mb-2" />
                                        <h5 className="card-title mb-1">RCS</h5>
                                        <div className="d-flex justify-content-between mt-3">
                                            <div>
                                                <p className="mb-1 text-muted small">Total</p>
                                                <h6 className="mb-0">
                                                    {rcsTotalCost.text.contact_count +
                                                        rcsTotalCost.richcardstandalone.contact_count +
                                                        rcsTotalCost.richcardcarousel.contact_count}
                                                </h6>
                                            </div>
                                            <div>
                                                <p className="mb-1 text-muted small">Delivered</p>
                                                <h6 className="mb-0">
                                                    {rcsTotalCost.text.delivered +
                                                        rcsTotalCost.richcardstandalone.delivered +
                                                        rcsTotalCost.richcardcarousel.delivered}
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Voice */}
                            <div className="col mb-2">
                                <div className="card shadow-sm border-0 h-100" style={{ minHeight: "150px" }}>
                                    <div className="card-body text-center">
                                        <FaVoicemail style={{ fontSize: "1.9em", color: "#fd7e14" }} className="mb-2" />
                                        <h5 className="card-title mb-1">Voice</h5>
                                        <div className="d-flex justify-content-between mt-3">
                                            <div>
                                                <p className="mb-1 text-muted small">Total</p>
                                                <h6 className="mb-0">{voiceTotalCost.total}</h6>
                                            </div>
                                            <div>
                                                <p className="mb-1 text-muted small">Delivered</p>
                                                <h6 className="mb-0">{voiceTotalCost.success}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Email */}
                            <div className="col mb-2">
                                <div className="card shadow-sm border-0 h-100" style={{ minHeight: "150px" }}>
                                    <div className="card-body text-center">
                                        <FaEnvelope style={{ fontSize: "1.9em", color: "#dc3545" }} className="mb-2" />
                                        <h5 className="card-title mb-1">Email</h5>
                                        <div className="d-flex justify-content-between mt-3">
                                            <div>
                                                <p className="mb-1 text-muted small">Total</p>
                                                <h6 className="mb-0">{emailTotalCost.total}</h6>
                                            </div>
                                            <div>
                                                <p className="mb-1 text-muted small">Delivered</p>
                                                <h6 className="mb-0">{emailTotalCost.delivered}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                )}

                {alert.status === true ? (
                    <div className={alert.bgColor} role="alert">
                        <button
                            type="button"
                            className="close"
                            data-dismiss="alert"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">×</span>
                        </button>
                        <div className="">{alert.errorMessage}</div>
                    </div>
                ) : null}
                <div className="row">
                    <div className="">
                        <div className="card">
                            {isLoading && <Spining />}

                            <div className="card-body">
                                <div className="filter-option">
                                    <h6 className="card-subtitle text-muted">Billing Summary</h6>
                                    <div className="row mb-2">
                                        {/* <div className="col-4">
                                            <select className="form-control" value={channel} onChange={handleChannelChange}>
                                                <option value="all">All Channel</option>
                                                <option value="sms">SMS</option>
                                                <option value="whatsapp">Whatsapp</option>
                                                <option value="rcs">RCS</option>
                                                <option value="voice">Voice</option>
                                                <option value="email">Email</option>
                                            </select>
                                        </div> */}
                                        <div className="col-md-6">
                                            <Select
                                                onChange={handleParentChange}
                                                options={parentList}
                                                value={selectedParent}
                                                isSearchable={true}
                                                placeholder="All Parent"
                                                isClearable={true}
                                                styles={customStyles}
                                            // isDisabled={true}
                                            // isDisabled={this.state.updateId ? true : false}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <Select
                                                onChange={handleUserChange}
                                                options={allusers}
                                                value={selecteduser}
                                                inputValue={userInputValue}
                                                onInputChange={handleUserInputChange}
                                                isSearchable={true}
                                                placeholder="Type at least 4 characters..."
                                                isClearable={true}
                                                styles={customStyles}
                                                isLoading={isLoadingUsers}
                                                filterOption={() => true}
                                                noOptionsMessage={() =>
                                                    userInputValue.length < 4
                                                        ? 'Type at least 4 characters to search'
                                                        : isLoadingUsers
                                                        ? 'Searching...'
                                                        : 'No record match'
                                                }
                                            />
                                        </div>

                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-5">
                                            <div className="input-group mb-2 mr-sm-2 table4">
                                                <div className="input-group-text">
                                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                                </div>
                                                <ReactDatePicker
                                                    className="form-control btn-block"
                                                    dateFormat="dd/MM/yyyy"
                                                    selected={fromdate}
                                                    onChange={fromdateHandler}
                                                    placeholderText="From Date"
                                                    // filterDate={filterAllowedDates}
                                                    maxDate={cutoffDate}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-5">
                                            <div className="input-group mb-2 mr-sm-2 table5">
                                                <div className="input-group-text">
                                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                                </div>
                                                <ReactDatePicker
                                                    className="form-control btn-block"
                                                    dateFormat="dd/MM/yyyy"
                                                    selected={todate}
                                                    onChange={todateHandler}
                                                    placeholderText="To Date"
                                                    maxDate={cutoffDate}
                                                    filterDate={filterToDate}
                                                />

                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <button type="button" onClick={Submit} className="btn btn-sm btn-info float-right">Submit</button>
                                        </div>

                                    </div>

                                    {Object.keys(billData).length > 0 && (
                                        <div className="row mb-3">
                                            <div className="col-md-12">
                                                <button
                                                    type="button"
                                                    onClick={downloadAllBillingExcel}
                                                    className="btn btn-sm btn-success float-right"
                                                >
                                                    <FontAwesomeIcon icon={faFileExcel} className="mr-1" /> Download Excel
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* <form className="form-row mb-3" id="EntityFormidFrom">
                                    <div className="col-md-12 d-flex justify-content-center mt-3">
                                        <button type="button" onClick={search} className="btn btn-sm btn-success">Submit</button>
                                    </div>
                                </form> */}

                                <div className="card">
                                    {/* <AdvanceDataTable
                                        tableName={""}
                                        tableCell={ADMIN_TOTAL_BILLING_SUMMARY}
                                        tableData={billData}
                                        isLoading={isLoading}
                                        isError={alert.errorMessage}
                                        filterstatus={true}
                                        pagination={true}
                                    /> */}

                                    <div className="">
                                        <div className="">

                                            <div className="p-2">

                                                <div className="">
                                                    <div className=" flex-fill">
                                                        {billData ?
                                                            <>

                                                                {selectedParent &&
                                                                    <div className="card">
                                                                        <div className="card-body">
                                                                            <div className="row">
                                                                                <div className="col-6">
                                                                                    <h6 className="mb-3">Parent Report</h6>
                                                                                </div>
                                                                                <div className="col-6">
                                                                                    <h6 className="mb-3 float-right">Total Amount : {parentTotalAmount}</h6>
                                                                                </div>
                                                                            </div>
                                                                            <div className="table-responsive">
                                                                                <table className="table table-striped table-bordered mb-0">
                                                                                    <thead className="bg-secondary text-white">
                                                                                        <tr>
                                                                                            <th>Channel</th>
                                                                                            <th>Category</th>
                                                                                            <th>CountryCode</th>
                                                                                            <th>Total</th>
                                                                                            <th>Delivered</th>
                                                                                            <th>Failed</th>
                                                                                            <th>Other</th>
                                                                                            <th>User Pulse (Voice)</th>
                                                                                            {/* <th>User Cost</th> */}
                                                                                            <th>Parent Cost</th>
                                                                                            {/* <th>Total Cost</th> */}
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {/* Whatsapp divided into Utility, Marketing, Authentication */}
                                                                                        {Object.entries(whatsappTotalCost).map(([countryCode, data]) => {
                                                                                            const categories = ["Utility", "Marketing", "Authentication"];

                                                                                            return categories.map((cat, index) => (
                                                                                                <tr key={`${countryCode}-${cat}`}>
                                                                                                    {index === 0 && (
                                                                                                        <td rowSpan="3">
                                                                                                            <IoLogoWhatsapp
                                                                                                                style={{ fontSize: "1.8em", color: "#25D366" }}
                                                                                                                className="mr-2"
                                                                                                            />
                                                                                                            Whatsapp
                                                                                                        </td>
                                                                                                    )}

                                                                                                    <td>{cat}</td>
                                                                                                    {/* <td>{countryCode}</td> */}
                                                                                                    <td>
                                                                                                        {countryCode} (
                                                                                                        {countryname.find(
                                                                                                            (x) => String(x.country_code) === String(countryCode)
                                                                                                        )?.country_name || "-"}
                                                                                                        )
                                                                                                    </td>

                                                                                                    <td>{data[cat]?.total || 0}</td>
                                                                                                    <td>{data[cat]?.delivered || 0}</td>
                                                                                                    <td>{data[cat]?.failed || 0}</td>
                                                                                                    <td>{data[cat]?.other || 0}</td>
                                                                                                    <td>-</td>
                                                                                                    {/* <td>{data[cat]?.submission_cost_user || 0}</td> */}
                                                                                                    <td>{data[cat]?.submission_cost_parent || 0}</td>
                                                                                                </tr>
                                                                                            ));
                                                                                        })}


                                                                                        {/* <tr>
                                                                                            <td>Marketing</td>
                                                                                            <td>91</td>
                                                                                            <td>{whatsappTotalCost.Marketing.total}</td>
                                                                                            <td>{whatsappTotalCost.Marketing.delivered}</td>
                                                                                            <td>{whatsappTotalCost.Marketing.failed}</td>
                                                                                            <td>{whatsappTotalCost.Marketing.other}</td>
                                                                                            <td>-</td>
                                                                                            <td>{whatsappTotalCost.Marketing.submission_cost_user}</td>
                                                                                            <td>{whatsappTotalCost.Marketing.submission_cost_parent}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>Authentication</td>
                                                                                            <td>91</td>
                                                                                            <td>{whatsappTotalCost.Authentication.total}</td>
                                                                                            <td>{whatsappTotalCost.Authentication.delivered}</td>
                                                                                            <td>{whatsappTotalCost.Authentication.failed}</td>
                                                                                            <td>{whatsappTotalCost.Authentication.other}</td>
                                                                                            <td>-</td>
                                                                                            <td>{whatsappTotalCost.Authentication.submission_cost_user}</td>
                                                                                            <td>{whatsappTotalCost.Authentication.submission_cost_parent}</td>
                                                                                        </tr> */}

                                                                                        {/* SMS */}
                                                                                        <tr>
                                                                                            <td>
                                                                                                <FaSms style={{ fontSize: '1.8em', color: '#007bff' }} className="mr-2" />
                                                                                                SMS
                                                                                            </td>
                                                                                            <td>-</td>
                                                                                            <td>91</td>
                                                                                            <td>{smsTotalCost.total}</td>
                                                                                            <td>{smsTotalCost.delivered}</td>
                                                                                            <td>{smsTotalCost.failed}</td>
                                                                                            <td>{smsTotalCost.other}</td>
                                                                                            <td>-</td>
                                                                                            {/* <td>{smsTotalCost.total_cost}</td> */}
                                                                                            <td>{smsTotalCost.total_cost_parent}</td>
                                                                                            {/* <td>{(parseFloat(smsInnarData?.total_cost) || 0).toFixed(2)}</td> */}
                                                                                        </tr>

                                                                                        {/* RCS */}
                                                                                        <tr>
                                                                                            <td rowSpan="3">
                                                                                                <MdChat style={{ fontSize: '1.8em', color: '#17a2b8' }} className="mr-2" />
                                                                                                RCS
                                                                                            </td>
                                                                                            <td>Text</td>
                                                                                            <td>91</td>
                                                                                            <td>{rcsTotalCost.text.contact_count}</td>
                                                                                            <td>{rcsTotalCost.text.delivered}</td>
                                                                                            <td>{rcsTotalCost.text.failed}</td>
                                                                                            <td>{rcsTotalCost.text.other}</td>
                                                                                            <td>-</td>
                                                                                            {/* <td>{rcsTotalCost.text.block_cr}</td> */}
                                                                                            <td>{rcsTotalCost.text.block_cr_parent}</td>
                                                                                        </tr>

                                                                                        <tr>
                                                                                            <td>RichCardStandAlone</td>
                                                                                            <td>91</td>
                                                                                            <td>{rcsTotalCost.richcardstandalone.contact_count}</td>
                                                                                            <td>{rcsTotalCost.richcardstandalone.delivered}</td>
                                                                                            <td>{rcsTotalCost.richcardstandalone.failed}</td>
                                                                                            <td>{rcsTotalCost.richcardstandalone.other}</td>
                                                                                            <td>-</td>
                                                                                            {/* <td>{rcsTotalCost.richcardstandalone.block_cr}</td> */}
                                                                                            <td>{rcsTotalCost.richcardstandalone.block_cr_parent}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>RichCardCarousel</td>
                                                                                            <td>91</td>
                                                                                            <td>{rcsTotalCost.richcardcarousel.contact_count}</td>
                                                                                            <td>{rcsTotalCost.richcardcarousel.delivered}</td>
                                                                                            <td>{rcsTotalCost.richcardcarousel.failed}</td>
                                                                                            <td>{rcsTotalCost.richcardcarousel.other}</td>
                                                                                            <td>-</td>
                                                                                            {/* <td>{rcsTotalCost.richcardcarousel.block_cr}</td> */}
                                                                                            <td>{rcsTotalCost.richcardcarousel.block_cr_parent}</td>
                                                                                        </tr>

                                                                                        {/* Voice */}
                                                                                        <tr>
                                                                                            <td>
                                                                                                <FaVoicemail style={{ fontSize: '1.8em', color: '#fd7e14' }} className="mr-2" />
                                                                                                Voice
                                                                                            </td>
                                                                                            <td>-</td>
                                                                                            <td>91</td>
                                                                                            <td>{voiceTotalCost.total}</td>
                                                                                            <td>{voiceTotalCost.success}</td>
                                                                                            <td>{voiceTotalCost.failed}</td>
                                                                                            <td>{voiceTotalCost.submitted}</td>
                                                                                            <td>{voiceTotalCost.total_pulse_15p / voiceTotalCost.total_pulse_30p || 0}</td>
                                                                                            {/* <td>{voiceTotalCost.total_cost}</td> */}
                                                                                            <td>{voiceTotalCost.total_cost_parent}</td>
                                                                                            {/* <td>$12.00</td> */}
                                                                                        </tr>
                                                                                        {/* Email */}
                                                                                        <tr>
                                                                                            <td>
                                                                                                <FaEnvelope style={{ fontSize: '1.8em', color: '#dc3545' }} className="mr-2" />
                                                                                                Email
                                                                                            </td>
                                                                                            <td>-</td>
                                                                                            <td>91</td>
                                                                                            <td>{emailTotalCost.total}</td>
                                                                                            <td>{emailTotalCost.delivered}</td>
                                                                                            <td>{emailTotalCost.failed}</td>
                                                                                            <td>{emailTotalCost.other}</td>
                                                                                            <td>-</td>
                                                                                            {/* <td>{emailTotalCost.total_cost}</td> */}
                                                                                            <td>{emailTotalCost.total_cost_parent}</td>

                                                                                        </tr>
                                                                                    </tbody>

                                                                                </table>
                                                                            </div>
                                                                        </div>
                                                                    </div>}

                                                                <div className='row mb-3'>
                                                                    <div className='col-6'>
                                                                        {Object.keys(billData).length > 0 &&
                                                                            <h6>Total Count: {filteredBillKeys.length}</h6>}
                                                                    </div>
                                                                    <div className='col-6'>
                                                                        <div className="input-group float-right">
                                                                            <div className="input-group-prepend">
                                                                                <span className="input-group-text"><FontAwesomeIcon icon={faSearch} /></span>
                                                                            </div>
                                                                            <input
                                                                                type="text"
                                                                                id="searchInput"
                                                                                name="searchdata"
                                                                                value={searchData}
                                                                                onChange={(e) => setSearchData(e.target.value)}
                                                                                className="form-control"
                                                                                placeholder="Search"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="table-responsive">
                                                                    <table className="table table-bordered">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Action</th>
                                                                                <th>Username</th>
                                                                                <th>Parent Username</th>
                                                                                <th style={{ cursor: "pointer" }} onClick={handleSort}>Total Amount <span
                                                                                    style={{
                                                                                        display: "inline-block",
                                                                                        transition: "transform 0.3s",
                                                                                        // transform: openKeys.includes(x) ? "rotate(180deg)" : "rotate(0deg)",
                                                                                        fontSize: "15px",
                                                                                        color: "white"
                                                                                    }}
                                                                                >
                                                                                    <FontAwesomeIcon icon={faSort} />
                                                                                </span></th>
                                                                                <th>Billing Type</th>
                                                                                <th>Auto Refund</th>
                                                                                <th>Billed/UnBilled</th>
                                                                                <th>History</th>
                                                                                <th>Meta Billing</th>
                                                                            </tr>
                                                                        </thead>
                                                                        {paginatedBillKeys
                                                                            .map((x) => {


                                                                                let WhatsappData = billData[x]?.whatsapp
                                                                                let sms = billData[x]?.sms
                                                                                let voice = billData[x]?.voice?.api
                                                                                let email = billData[x]?.email?.api
                                                                                let username = billData[x].username
                                                                                let totalAmount = billData[x].totalAmount
                                                                                let parentName = billData[x].parent
                                                                                let rcsParentname = billData[x].parentname
                                                                                let billing_type = billData[x].parent_biling_type
                                                                                let user_billing_type = billData[x].user_biling_type
                                                                                let autoRefund = billData[x].auto_refund
                                                                                let userID = billData[x].user_id
                                                                                let rcsPannel = billData[x]?.rcs?.PANEL
                                                                                let rcsBulkApi = billData[x]?.rcs?.BULKAPI
                                                                                let conversation = billData[x]?.whatsapp?.conv?.sms_cost
                                                                                let agentBillingData = billData[x]?.agent?.data
                                                                                let agentBillingTotalData = billData[x]?.agent?.totals
                                                                                let rcsDataPannel = ""
                                                                                let userCurrency = billData[x].user_currency



                                                                                let WhatsappInnerData = {}
                                                                                let WhatsappCampInnerData = {}
                                                                                let smsInnarData = {}
                                                                                let smsCampInnerData = {}
                                                                                let whatsappCountryCode = ""
                                                                                let smsCountryCode = ""
                                                                                let rcstexttemplate = []
                                                                                let rcsrichcardtemplate = []
                                                                                let rcscarouseltemplate = []

                                                                                let rcsTextData = {};
                                                                                let rcsRichCardData = {};
                                                                                let rcsCarouselData = {};

                                                                                // console.log(rcsRichCardData);


                                                                                // let agentData = {};

                                                                                let rcsTextBulkData = {};
                                                                                let rcsRichCardBulkData = {};
                                                                                let rcsCarouselBulkData = {};

                                                                                // 1. Collect all unique countryCodes from sms.api and sms.camp
                                                                                const countryCodes = new Set([
                                                                                    ...Object.keys(sms?.api || {}),
                                                                                    ...Object.keys(sms?.camp || {}),
                                                                                ]);

                                                                                Object.keys(WhatsappData?.api || {}).map((whatsappmatch) => {
                                                                                    WhatsappInnerData = WhatsappData.api[whatsappmatch]
                                                                                    whatsappCountryCode = whatsappmatch
                                                                                });

                                                                                Object.keys(WhatsappData?.camp || {}).map((whatsappCampmatch) => {
                                                                                    WhatsappCampInnerData = WhatsappData.camp[whatsappCampmatch]
                                                                                    whatsappCountryCode = whatsappCampmatch
                                                                                });

                                                                                //sms api Data
                                                                                Object.keys(sms?.api || {}).map((smsmatch) => {
                                                                                    smsInnarData = sms.api[smsmatch]
                                                                                    smsCountryCode = smsmatch
                                                                                })

                                                                                //sms camp Data
                                                                                Object.keys(sms?.camp || {}).map((smsCampmatch) => {
                                                                                    smsCampInnerData = sms.camp[smsCampmatch]
                                                                                    smsCountryCode = smsCampmatch
                                                                                })

                                                                                // if (rcsPannel && Array.isArray(rcsPannel)) {
                                                                                //     rcsPannel.forEach((item) => {
                                                                                //         if (Array.isArray(item)) {
                                                                                //             item.forEach((innerItem) => {
                                                                                //                 // Do something with each innerItem
                                                                                //                 rcsDataPannel = innerItem;
                                                                                //             });
                                                                                //         } else {
                                                                                //             // If item is a single object, not an array
                                                                                //             rcsDataPannel = item;
                                                                                //         }
                                                                                //     });
                                                                                // }
                                                                                if (rcsPannel && Array.isArray(rcsPannel)) {
                                                                                    rcsPannel.forEach(item => {

                                                                                        const dataItem = Array.isArray(item) ? item[0] : item; // Flatten if needed

                                                                                        if (dataItem.rcs_type === "text") {
                                                                                            rcsTextData = dataItem.data || {};
                                                                                        } else if (dataItem.rcs_type === "richcardstandalone") {
                                                                                            rcsRichCardData = dataItem.data || {};
                                                                                        } else if (dataItem.rcs_type === "richcardcarousel") {
                                                                                            rcsCarouselData = dataItem.data || {};
                                                                                        }
                                                                                    });
                                                                                }

                                                                                if (rcsBulkApi && Array.isArray(rcsBulkApi)) {
                                                                                    rcsBulkApi.forEach(item => {

                                                                                        const dataItem = Array.isArray(item) ? item[0] : item; // Flatten if needed

                                                                                        if (dataItem.rcs_type === "text") {
                                                                                            rcsTextBulkData = dataItem.data || {};
                                                                                        } else if (dataItem.rcs_type === "richcardstandalone") {
                                                                                            rcsRichCardBulkData = dataItem.data || {};
                                                                                        } else if (dataItem.rcs_type === "richcardcarousel") {
                                                                                            rcsCarouselBulkData = dataItem.data || {};
                                                                                        }
                                                                                    });
                                                                                }

                                                                                // ── Channel-wise totals for this user's detail report ──
                                                                                // WhatsApp
                                                                                const _waCodes = Array.from(new Set(
                                                                                    Object.entries(WhatsappData || {}).flatMap(([, src]) => Object.keys(src || {}))
                                                                                ));
                                                                                let waTotals = { total: 0, delivered: 0, failed: 0, other: 0, sentCount: 0 };
                                                                                _waCodes.forEach(cc => {
                                                                                    const srcs = Object.entries(WhatsappData || {}).map(([, src]) => src?.[cc] || {});
                                                                                    ['Utility', 'Marketing', 'Authentication'].forEach(cat => {
                                                                                        const rows = srcs.map(d => d?.[cat] || {});
                                                                                        waTotals.total += rows.reduce((s, i) => s + (parseInt(i.total) || 0), 0);
                                                                                        waTotals.delivered += rows.reduce((s, i) => s + (parseInt(i.delivered) || 0), 0);
                                                                                        waTotals.failed += rows.reduce((s, i) => s + (parseInt(i.failed) || 0), 0);
                                                                                        waTotals.other += rows.reduce((s, i) => s + (parseInt(i.other) || 0), 0);
                                                                                        waTotals.sentCount += rows.reduce((s, i) => s + (parseInt(i.sent_count) || 0), 0);
                                                                                    });
                                                                                });

                                                                                // SMS
                                                                                let smsTotals = { total: 0, delivered: 0, failed: 0, other: 0, sentCount: 0 };
                                                                                Array.from(new Set([...Object.keys(sms?.api || {}), ...Object.keys(sms?.camp || {})])).forEach(cc => {
                                                                                    const a = sms?.api?.[cc] || {}, c = sms?.camp?.[cc] || {};
                                                                                    smsTotals.total += (parseInt(a.total) || 0) + (parseInt(c.total) || 0);
                                                                                    smsTotals.delivered += (parseInt(a.delivered) || 0) + (parseInt(c.delivered) || 0);
                                                                                    smsTotals.failed += (parseInt(a.failed) || 0) + (parseInt(c.failed) || 0);
                                                                                    smsTotals.other += (parseInt(a.other) || 0) + (parseInt(c.other) || 0);
                                                                                    smsTotals.sentCount += (parseInt(a.sent_count) || 0) + (parseInt(c.sent_count) || 0);
                                                                                });

                                                                                // RCS
                                                                                const rcsTotals = {
                                                                                    total: (rcsTextData.contact_count || 0) + (rcsTextBulkData.contact_count || 0) + (rcsRichCardData.contact_count || 0) + (rcsRichCardBulkData.contact_count || 0) + (rcsCarouselData.contact_count || 0) + (rcsCarouselBulkData.contact_count || 0),
                                                                                    delivered: (rcsTextData.deliver_count || 0) + (rcsTextBulkData.deliver_count || 0) + (rcsRichCardData.deliver_count || 0) + (rcsRichCardBulkData.deliver_count || 0) + (rcsCarouselData.deliver_count || 0) + (rcsCarouselBulkData.deliver_count || 0),
                                                                                    failed: (rcsTextData.fail_count || 0) + (rcsTextBulkData.fail_count || 0) + (rcsRichCardData.fail_count || 0) + (rcsRichCardBulkData.fail_count || 0) + (rcsCarouselData.fail_count || 0) + (rcsCarouselBulkData.fail_count || 0),
                                                                                    other: (rcsTextData.other_count || 0) + (rcsTextBulkData.other_count || 0) + (rcsRichCardData.other_count || 0) + (rcsRichCardBulkData.other_count || 0) + (rcsCarouselData.other_count || 0) + (rcsCarouselBulkData.other_count || 0),
                                                                                    sentCount: 0,
                                                                                };

                                                                                // Voice
                                                                                const voiceTotals = {
                                                                                    total: parseInt(voice?.total || 0),
                                                                                    delivered: parseInt(voice?.success || 0),
                                                                                    failed: parseInt(voice?.failed || 0),
                                                                                    other: parseInt(voice?.submitted || 0),
                                                                                    sentCount: 0,
                                                                                };

                                                                                // Email
                                                                                const emailTotals = {
                                                                                    total: parseInt(email?.total || 0),
                                                                                    delivered: parseInt(email?.delivered || 0),
                                                                                    failed: parseInt(email?.failed || 0),
                                                                                    other: parseInt(email?.other || 0),
                                                                                    sentCount: 0,
                                                                                };

                                                                                const TotalRow = ({ label, t }) => (
                                                                                    <tr style={{ background: "#f1f5f9", fontWeight: "600", borderTop: "2px solid #cbd5e1", borderBottom: "2px solid #cbd5e1" }}>
                                                                                        <td colSpan="3" style={{ padding: "9px 16px", fontSize: "13px", color: "#0f172a", textAlign: "right", fontWeight: "700" }}>
                                                                                            {label}
                                                                                        </td>
                                                                                        <td style={{ padding: "9px 16px", color: "#0f172a" }}>{t.total}</td>
                                                                                        <td style={{ padding: "9px 16px", color: "#0f172a" }}>{t.delivered}</td>
                                                                                        <td style={{ padding: "9px 16px", color: "#0f172a" }}>{t.failed}</td>
                                                                                        <td style={{ padding: "9px 16px", color: "#0f172a" }}>{t.other}</td>
                                                                                        <td style={{ padding: "9px 16px", color: "#0f172a" }}>{t.sentCount}</td>
                                                                                        <td colSpan="4" style={{ padding: "9px 16px", color: "#94a3b8" }}>—</td>
                                                                                    </tr>
                                                                                );

                                                                                return (
                                                                                    <tbody key={x}>
                                                                                        <React.Fragment key={x}>
                                                                                            <tr>
                                                                                                <td style={{ cursor: "pointer", width: "40px", textAlign: "center" }}>
                                                                                                    <button
                                                                                                        className="btn btn-link p-0"
                                                                                                        onClick={() => toggleAccordion(x)}
                                                                                                        aria-expanded={openKeys.includes(x)}
                                                                                                        aria-controls={`accordion-collapse-${x}`}
                                                                                                    >
                                                                                                        <span
                                                                                                            style={{
                                                                                                                display: "inline-block",
                                                                                                                transition: "transform 0.3s",
                                                                                                                transform: openKeys.includes(x) ? "rotate(180deg)" : "rotate(0deg)",
                                                                                                                fontSize: "18px",
                                                                                                                color: "black"
                                                                                                            }}
                                                                                                        >
                                                                                                            ▼
                                                                                                        </span>
                                                                                                    </button>
                                                                                                </td>
                                                                                                <td>{username}</td>
                                                                                                <td>
                                                                                                    {parentName || rcsParentname}
                                                                                                    <br />
                                                                                                    <strong>{billing_type && `(${billing_type})`}</strong>
                                                                                                </td>
                                                                                                <td>
                                                                                                    {/* {(
                                                                                                        (parseFloat(smsInnarData?.total_cost) || 0) +
                                                                                                        (parseFloat(smsCampInnerData?.total_cost_user) || 0) +
                                                                                                        (parseFloat(WhatsappInnerData.Utility?.submission_cost_user) || 0) +
                                                                                                        (parseFloat(WhatsappCampInnerData.Utility?.submission_cost_user) || 0) +
                                                                                                        (parseFloat(WhatsappInnerData.Marketing?.submission_cost_user) || 0) +
                                                                                                        (parseFloat(WhatsappCampInnerData.Marketing?.submission_cost_user) || 0) +
                                                                                                        (parseFloat(WhatsappInnerData.Authentication?.submission_cost_user) || 0) +
                                                                                                        (parseFloat(WhatsappCampInnerData.Authentication?.submission_cost_user) || 0) +
                                                                                                        (parseFloat(voice?.total_cost) || 0) +
                                                                                                        (parseFloat(email?.total_cost) || 0) +
                                                                                                        (parseFloat(rcsTextData.block_cr) || 0) +
                                                                                                        (parseFloat(rcsRichCardData.block_cr) || 0) +
                                                                                                        (parseFloat(rcsCarouselData.block_cr) || 0)
                                                                                                    ).toFixed(2)} */}
                                                                                                    {/* {userCurrency === "INR" ? totalAmount : userCurrency === "USD" ? totalAmount * inr : userCurrency === "EUR" ? (totalAmount / eur) * inr : 0} */}
                                                                                                    {parseFloat(totalAmount).toFixed(6)}
                                                                                                </td>
                                                                                                <td>{user_billing_type ? user_billing_type : <span>Prepaid</span>}</td>
                                                                                                <td>{autoRefund ? autoRefund : "NO"}</td>
                                                                                                <td>
                                                                                                    <select
                                                                                                        value={billStatus[x] || 'unbilled'}  // default to 'unbilled'
                                                                                                        className="form-control"
                                                                                                        onChange={(e) => handleBillStatus(x, e.target.value)}
                                                                                                    >
                                                                                                        <option value="unbilled">UnBilled</option>
                                                                                                        <option value="billed">Billed</option>
                                                                                                    </select>
                                                                                                </td>
                                                                                                <td>
                                                                                                    <a
                                                                                                        href={`/admin/admin-transaction-history/${userID}/${x}`}
                                                                                                        target="_blank"
                                                                                                        rel="noopener noreferrer"
                                                                                                        className="ml-3"
                                                                                                        style={{ cursor: "pointer" }}
                                                                                                    >
                                                                                                        <FontAwesomeIcon icon={faEye} />
                                                                                                    </a>
                                                                                                </td>
                                                                                                <td style={{ textAlign: "center" }}>
                                                                                                    <FontAwesomeIcon
                                                                                                        icon={faEye}
                                                                                                        style={{ cursor: "pointer" }}
                                                                                                        onClick={() => openBrandNumberModal(userID, username)}
                                                                                                    />
                                                                                                </td>
                                                                                            </tr>

                                                                                            <tr>
                                                                                                <td colSpan="9" className="p-0 border-0">
                                                                                                    <div
                                                                                                        id={`accordion-collapse-${x}`}
                                                                                                        className={`collapse ${openKeys.includes(x) ? "show" : ""}`}
                                                                                                    >
                                                                                                        {/* accordion content */}
                                                                                                        <div className="p-3 bg-light">
                                                                                                            <div className="card">
                                                                                                                <div className="card-body">
                                                                                                                    <h6 className="mb-3">Detail Report</h6>
                                                                                                                    <div className="table-responsive">
                                                                                                                        <table className="table table-striped table-bordered mb-0">
                                                                                                                            <thead className="bg-secondary text-white">
                                                                                                                                <tr>
                                                                                                                                    <th>Channel</th>
                                                                                                                                    <th>Category</th>
                                                                                                                                    <th>CountryCode</th>
                                                                                                                                    <th>Total</th>
                                                                                                                                    <th>Delivered</th>
                                                                                                                                    <th>Failed</th>
                                                                                                                                    <th>Other</th>
                                                                                                                                    <th>Sent Count</th>
                                                                                                                                    <th>User Pulse (Voice)</th>
                                                                                                                                    <th>Price</th>
                                                                                                                                    <th>User Cost</th>
                                                                                                                                    <th>Parent Cost</th>
                                                                                                                                    {/* <th>Total Cost</th> */}
                                                                                                                                </tr>
                                                                                                                            </thead>
                                                                                                                            <tbody>
                                                                                                                                {/* Whatsapp divided into Utility, Marketing, Authentication */}
                                                                                                                                {(() => {
                                                                                                                                    // 1) Collect all unique country codes from all sources
                                                                                                                                    const countryCodesSet = new Set();
                                                                                                                                    Object.entries(WhatsappData || {}).forEach(([sourceKey, sourceData]) => {
                                                                                                                                        if (!sourceData || typeof sourceData !== 'object') return;
                                                                                                                                        Object.keys(sourceData).forEach(countryCode => countryCodesSet.add(countryCode));
                                                                                                                                    });
                                                                                                                                    const uniqueCountryCodes = Array.from(countryCodesSet);

                                                                                                                                    // Calculate total number of rows (all categories of all countries)
                                                                                                                                    const totalRows = uniqueCountryCodes.reduce((count, countryCode) => {
                                                                                                                                        const dataPerSource = Object.entries(WhatsappData || {}).map(([sourceKey, sourceData]) => {
                                                                                                                                            return sourceData?.[countryCode] || {};
                                                                                                                                        });
                                                                                                                                        const categories = ['Utility', 'Marketing', 'Authentication'].filter(
                                                                                                                                            cat => dataPerSource.some(data => data[cat])
                                                                                                                                        );
                                                                                                                                        return count + categories.length;
                                                                                                                                    }, 0);

                                                                                                                                    let renderedRows = 0; // To track where to place the logo

                                                                                                                                    return uniqueCountryCodes.map(countryCode => {
                                                                                                                                        const dataPerSource = Object.entries(WhatsappData || {}).map(([sourceKey, sourceData]) => {
                                                                                                                                            return sourceData?.[countryCode] || {};
                                                                                                                                        });

                                                                                                                                        const categories = ['Utility', 'Marketing', 'Authentication'].filter(
                                                                                                                                            cat => dataPerSource.some(data => data[cat])
                                                                                                                                        );

                                                                                                                                        const billItem = billData.find(bill => bill.countryCode === countryCode) || {};

                                                                                                                                        return categories.length > 0
                                                                                                                                            ? categories.map((category, catIndex) => {
                                                                                                                                                const combined = dataPerSource.map(data => data?.[category] || {});

                                                                                                                                                const total = combined.reduce((sum, item) => sum + (parseInt(item.total) || 0), 0);
                                                                                                                                                const delivered = combined.reduce((sum, item) => sum + (parseInt(item.delivered) || 0), 0);
                                                                                                                                                const SentCount = combined.reduce((sum, item) => sum + (parseInt(item.sent_count) || 0), 0);
                                                                                                                                                const failed = combined.reduce((sum, item) => sum + (parseInt(item.failed) || 0), 0);
                                                                                                                                                const other = combined.reduce((sum, item) => sum + (parseInt(item.other) || 0), 0);
                                                                                                                                                const per_wp_cost = (
                                                                                                                                                    parseFloat(combined.find(item => item.per_wp_cost)?.per_wp_cost ?? 0)
                                                                                                                                                ).toFixed(6);
                                                                                                                                                const submission_cost_user = combined
                                                                                                                                                    .reduce((sum, item) => sum + (parseFloat(item.submission_cost_user) || 0), 0)
                                                                                                                                                    .toFixed(6);
                                                                                                                                                const submission_cost_parent = combined
                                                                                                                                                    .reduce((sum, item) => sum + (parseFloat(item.submission_cost_parent) || 0), 0)
                                                                                                                                                    .toFixed(6);

                                                                                                                                                renderedRows++;

                                                                                                                                                return (
                                                                                                                                                    <>
                                                                                                                                                        <tr key={`${countryCode}-${category}`}>
                                                                                                                                                            {/* Show WhatsApp logo only in the very first row */}
                                                                                                                                                            {renderedRows === 1 && (
                                                                                                                                                                <td rowSpan={totalRows}>
                                                                                                                                                                    <IoLogoWhatsapp
                                                                                                                                                                        style={{ fontSize: "1.8em", color: "#25D366" }}
                                                                                                                                                                        className="mr-2"
                                                                                                                                                                    />
                                                                                                                                                                    Whatsapp
                                                                                                                                                                    <span className="ml-1">
                                                                                                                                                                        {billItem?.whatsappbm === "1" ? "(Delivery)" : "(Submission)"}
                                                                                                                                                                    </span>
                                                                                                                                                                </td>
                                                                                                                                                            )}
                                                                                                                                                            <td>{category}</td>
                                                                                                                                                            <td>
                                                                                                                                                                {countryCode} (
                                                                                                                                                                {countryname.find(
                                                                                                                                                                    (x) => String(x.country_code) === String(countryCode)
                                                                                                                                                                )?.country_name || "-"}
                                                                                                                                                                )
                                                                                                                                                            </td>
                                                                                                                                                            <td>{total}</td>

                                                                                                                                                            {/* Replace SentCount with Info button */}
                                                                                                                                                            <td>
                                                                                                                                                                {delivered}{" "}
                                                                                                                                                            </td>

                                                                                                                                                            <td>{failed}</td>
                                                                                                                                                            <td>{other}</td>
                                                                                                                                                            <td>{SentCount}</td>
                                                                                                                                                            <td>-</td>
                                                                                                                                                            <td>{per_wp_cost}</td>
                                                                                                                                                            <td>{submission_cost_user}</td>
                                                                                                                                                            <td>{submission_cost_parent}</td>
                                                                                                                                                        </tr>
                                                                                                                                                    </>
                                                                                                                                                );
                                                                                                                                            })
                                                                                                                                            : null;
                                                                                                                                    });
                                                                                                                                })()}

                                                                                                                                <TotalRow label="WhatsApp Total" t={waTotals} />

                                                                                                                                {conversation &&
                                                                                                                                    <tr>
                                                                                                                                        <td>
                                                                                                                                            <IoLogoWhatsapp
                                                                                                                                                style={{ fontSize: "1.8em", color: "#25D366" }}
                                                                                                                                                className="mr-2"
                                                                                                                                            />
                                                                                                                                            Whatsapp Conversation</td>
                                                                                                                                        <table>
                                                                                                                                            <thead>
                                                                                                                                                <tr>
                                                                                                                                                    <th>Price</th>
                                                                                                                                                    <th>Count</th>
                                                                                                                                                </tr>
                                                                                                                                            </thead>
                                                                                                                                            <tbody>
                                                                                                                                                {conversation && typeof conversation === 'object' &&
                                                                                                                                                    Object.entries(conversation).map(([key, value]) => (
                                                                                                                                                        <tr key={key}>
                                                                                                                                                            <td>{key}</td>
                                                                                                                                                            <td>{value}</td>
                                                                                                                                                        </tr>
                                                                                                                                                    ))
                                                                                                                                                }
                                                                                                                                            </tbody>
                                                                                                                                        </table>


                                                                                                                                    </tr>}

                                                                                                                                {/* SMS */}
                                                                                                                                {(() => {
                                                                                                                                    const apiCountries = Object.keys(sms?.api || {});
                                                                                                                                    const campCountries = Object.keys(sms?.camp || {});
                                                                                                                                    const uniqueCountryCodes = Array.from(new Set([...apiCountries, ...campCountries]));

                                                                                                                                    return uniqueCountryCodes.map((countryCode, index) => {
                                                                                                                                        const apiData = sms?.api?.[countryCode] || {};
                                                                                                                                        const campData = sms?.camp?.[countryCode] || {};
                                                                                                                                        const billItem = billData.find(b => b.countryCode === countryCode) || {};

                                                                                                                                        const total = (parseInt(apiData.total) || 0) + (parseInt(campData.total) || 0);
                                                                                                                                        const delivered = (parseInt(apiData.delivered) || 0) + (parseInt(campData.delivered) || 0);
                                                                                                                                        const sentCount = (parseInt(apiData.sent_count) || 0) + (parseInt(campData.sent_count) || 0);
                                                                                                                                        const failed = (parseInt(apiData.failed) || 0) + (parseInt(campData.failed) || 0);
                                                                                                                                        const other = (parseInt(apiData.other) || 0) + (parseInt(campData.other) || 0);

                                                                                                                                        const per_sms_cost = (
                                                                                                                                            parseFloat(apiData.per_sms_cost ?? campData.per_sms_cost ?? 0)
                                                                                                                                        ).toFixed(6);

                                                                                                                                        const total_cost = (
                                                                                                                                            (parseFloat(apiData.total_cost || apiData.total_cost_user) || 0) +
                                                                                                                                            (parseFloat(campData.total_cost || campData.total_cost_user) || 0)
                                                                                                                                        ).toFixed(6);

                                                                                                                                        const total_cost_parent = (
                                                                                                                                            (parseFloat(apiData.total_cost_parent) || 0) +
                                                                                                                                            (parseFloat(campData.total_cost_parent) || 0)
                                                                                                                                        ).toFixed(6);

                                                                                                                                        return (
                                                                                                                                            <tr key={`sms-${countryCode}-${index}`}>
                                                                                                                                                {/* Show SMS logo only in the first row */}
                                                                                                                                                {index === 0 ? (
                                                                                                                                                    <td rowSpan={uniqueCountryCodes.length}>
                                                                                                                                                        <FaSms style={{ fontSize: '1.8em', color: '#007bff' }} className="mr-2" />
                                                                                                                                                        SMS
                                                                                                                                                        <span className="ml-1">
                                                                                                                                                            {billItem?.smsbm === "1" ? "(Delivery)" : "(Submission)"}
                                                                                                                                                        </span>
                                                                                                                                                    </td>
                                                                                                                                                ) : null}

                                                                                                                                                {/* Empty cell for logo column if not first row */}
                                                                                                                                                {index !== 0 && null}

                                                                                                                                                <td>-</td>
                                                                                                                                                <td>
                                                                                                                                                    {countryCode}{" "}
                                                                                                                                                    (
                                                                                                                                                    {countryname == "9999" ? <span>(multiple)</span> :
                                                                                                                                                        countryname.find(
                                                                                                                                                            (x) => String(x.country_code) === String(countryCode)
                                                                                                                                                        )?.country_name || "-"
                                                                                                                                                    }
                                                                                                                                                    )
                                                                                                                                                </td>
                                                                                                                                                <td>{total}</td>
                                                                                                                                                <td>{delivered}</td>
                                                                                                                                                <td>{failed}</td>
                                                                                                                                                <td>{other}</td>
                                                                                                                                                <td>-</td>
                                                                                                                                                <td>{per_sms_cost}</td>
                                                                                                                                                <td>{total_cost}</td>
                                                                                                                                                <td>{total_cost_parent}</td>
                                                                                                                                            </tr>
                                                                                                                                        );
                                                                                                                                    });
                                                                                                                                })()}

                                                                                                                                <TotalRow label="SMS Total" t={smsTotals} />

                                                                                                                                {/* RCS */}
                                                                                                                                <tr>
                                                                                                                                    <td rowSpan="3">
                                                                                                                                        <MdChat style={{ fontSize: '1.8em', color: '#17a2b8' }} className="mr-2" />
                                                                                                                                        RCS
                                                                                                                                        <span className="ml-1">
                                                                                                                                            {billData[x].rcsbm == "1" ? <span>(Delivery)</span> : <span>(Submission)</span>}
                                                                                                                                        </span>
                                                                                                                                    </td>
                                                                                                                                    <td>Text</td>
                                                                                                                                    <td>91 (India)</td>
                                                                                                                                    <td>{((rcsTextData.contact_count || 0) + (rcsTextBulkData.contact_count || 0)) || 0}</td>
                                                                                                                                    <td>{((rcsTextData.deliver_count || 0) + (rcsTextBulkData.deliver_count || 0)) || 0}</td>
                                                                                                                                    <td>{((rcsTextData.fail_count || 0) + (rcsTextBulkData.fail_count || 0)) || 0}</td>
                                                                                                                                    <td>{((rcsTextData.other_count || 0) + (rcsTextBulkData.other_count || 0)) || 0}</td>
                                                                                                                                    <td>-</td>
                                                                                                                                    <td>-</td>
                                                                                                                                    <td>{((rcsTextData.block_cr || 0) + (rcsTextBulkData.block_cr || 0)) || 0}</td>
                                                                                                                                    <td>{((rcsTextData.block_cr_parent || 0) + (rcsTextBulkData.block_cr_parent || 0)) || 0}</td>
                                                                                                                                </tr>
                                                                                                                                <tr>
                                                                                                                                    <td>RichCardStandAlone</td>
                                                                                                                                    <td>91 (India)</td>
                                                                                                                                    <td>{((rcsRichCardData.contact_count || 0) + (rcsRichCardBulkData.contact_count || 0)) || 0}</td>
                                                                                                                                    <td>{((rcsRichCardData.deliver_count || 0) + (rcsRichCardBulkData.deliver_count || 0)) || 0}</td>
                                                                                                                                    <td>{((rcsRichCardData.fail_count || 0) + (rcsRichCardBulkData.fail_count || 0)) || 0}</td>
                                                                                                                                    <td>{((rcsRichCardData.other_count || 0) + (rcsRichCardBulkData.other_count || 0)) || 0}</td>
                                                                                                                                    <td>-</td>
                                                                                                                                    <td>-</td>
                                                                                                                                    <td>{((rcsRichCardData.block_cr || 0) + (rcsRichCardBulkData.block_cr || 0)) || 0}</td>
                                                                                                                                    <td>{((rcsRichCardData.block_cr_parent || 0) + (rcsRichCardBulkData.block_cr_parent || 0)) || 0}</td>
                                                                                                                                </tr>
                                                                                                                                <tr>
                                                                                                                                    <td>RichCardCarousel</td>
                                                                                                                                    <td>91 (India)</td>
                                                                                                                                    <td>{((rcsCarouselData.contact_count || 0) + (rcsCarouselBulkData.contact_count || 0)) || 0}</td>
                                                                                                                                    <td>{((rcsCarouselData.deliver_count || 0) + (rcsCarouselBulkData.contact_count || 0)) || 0}</td>
                                                                                                                                    <td>{((rcsCarouselData.fail_count || 0) + (rcsCarouselBulkData.contact_count || 0)) || 0}</td>
                                                                                                                                    <td>{((rcsCarouselData.other_count || 0) + (rcsCarouselBulkData.contact_count || 0)) || 0}</td>
                                                                                                                                    <td>-</td>
                                                                                                                                    <td>-</td>
                                                                                                                                    <td>{((rcsCarouselData.block_cr || 0) + (rcsCarouselBulkData.contact_count || 0)) || 0}</td>
                                                                                                                                    <td>{((rcsCarouselData.block_cr_parent || 0) + (rcsCarouselBulkData.contact_count || 0)) || 0}</td>
                                                                                                                                </tr>

                                                                                                                                <TotalRow label="RCS Total" t={rcsTotals} />

                                                                                                                                <tr>
                                                                                                                                    <td>
                                                                                                                                        <FaVoicemail style={{ fontSize: '1.8em', color: '#fd7e14' }} className="mr-2" />
                                                                                                                                        Voice
                                                                                                                                        <span className="ml-1">{billData[x].voicebm == "1" ? <span>(Delivery)</span> : <span>(Submission)</span>}</span>
                                                                                                                                    </td>
                                                                                                                                    <td>-</td>
                                                                                                                                    <td>91 (India)</td>
                                                                                                                                    <td>{voice?.total || 0}</td>
                                                                                                                                    <td>{voice?.success || 0}</td>
                                                                                                                                    <td>{voice?.failed || 0}</td>
                                                                                                                                    <td>{voice?.submitted || 0}</td>
                                                                                                                                    <td>{voice?.user_pulse === "15" ? voice?.total_pulse_15p : voice?.user_pulse === "30" ? voice?.total_pulse_30p : 0}</td>
                                                                                                                                    <td>-</td>
                                                                                                                                    <td>{parseFloat(voice?.total_cost || 0).toFixed(6)}</td>
                                                                                                                                    <td>{parseFloat(voice?.total_cost_parent || 0).toFixed(6)}</td>
                                                                                                                                    {/* <td>$12.00</td> */}
                                                                                                                                </tr>

                                                                                                                                <TotalRow label="Voice Total" t={voiceTotals} />

                                                                                                                                {/* Email */}
                                                                                                                                <tr>
                                                                                                                                    <td>
                                                                                                                                        <FaEnvelope style={{ fontSize: '1.8em', color: '#dc3545' }} className="mr-2" />
                                                                                                                                        Email
                                                                                                                                        <span className="ml-1">{billData[x].emailbm == "1" ? <span>(Delivery)</span> : <span>(Submission)</span>}</span>
                                                                                                                                    </td>
                                                                                                                                    <td>-</td>
                                                                                                                                    <td>91 (India)</td>
                                                                                                                                    <td>{email?.total || 0}</td>
                                                                                                                                    <td>{email?.delivered || 0}</td>
                                                                                                                                    <td>{email?.failed || 0}</td>
                                                                                                                                    <td>{email?.other || 0}</td>
                                                                                                                                    <td>-</td>
                                                                                                                                    <td>{parseFloat(email?.per_email_cost || 0).toFixed(6)}</td>
                                                                                                                                    <td>{parseFloat(email?.total_cost || 0).toFixed(6)}</td>
                                                                                                                                    <td>{parseFloat(email?.total_cost_parent || 0).toFixed(6)}</td>

                                                                                                                                </tr>

                                                                                                                                <TotalRow label="Email Total" t={emailTotals} />

                                                                                                                                <tr>
                                                                                                                                    <td>
                                                                                                                                        <FaEnvelope style={{ fontSize: '1.8em', color: '#dc3545' }} className="mr-2" />
                                                                                                                                        Agent
                                                                                                                                        {/* <span className="ml-1">{billData[x].emailbm == "1" ? <span>(Delivery)</span> : <span>(Submission)</span>}</span> */}
                                                                                                                                    </td>
                                                                                                                                    <td>-</td>
                                                                                                                                    <td>91 (India)</td>
                                                                                                                                    <td>{email?.total || 0}</td>
                                                                                                                                    <td>{email?.delivered || 0}</td>
                                                                                                                                    <td>{email?.failed || 0}</td>
                                                                                                                                    <td>{email?.other || 0}</td>
                                                                                                                                    <td>-</td>
                                                                                                                                    <td>{parseFloat(email?.per_email_cost || 0).toFixed(6)}</td>
                                                                                                                                    <td>{parseFloat(email?.total_cost || 0).toFixed(6)}</td>
                                                                                                                                    <td>{parseFloat(email?.total_cost_parent || 0).toFixed(6)}</td>

                                                                                                                                </tr>

                                                                                                                            </tbody>

                                                                                                                        </table>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                <div className="card-body">
                                                                                                                    <h6 className="mb-3">Agent Report</h6>
                                                                                                                    <div className="table-responsive">
                                                                                                                        <table className="table table-striped table-bordered mb-0">
                                                                                                                            <thead className="bg-secondary text-white">
                                                                                                                                <tr>
                                                                                                                                    <th>Channel</th>
                                                                                                                                    <th>Total Paid Amounts</th>
                                                                                                                                    <th>Total Outstanding Amounts</th>
                                                                                                                                    <th>Total Bills</th>
                                                                                                                                    <th>Billing Type</th>
                                                                                                                                    <th>Bill Year</th>
                                                                                                                                    <th>Bill Month</th>
                                                                                                                                    <th>Paid Amount</th>
                                                                                                                                    <th>Paid Through</th>
                                                                                                                                    <th>Outstanding Amount</th>
                                                                                                                                    <th>Status</th>
                                                                                                                                    <th>Paid Date</th>
                                                                                                                                    <th>Created At</th>
                                                                                                                                    <th>Action</th>
                                                                                                                                    {/* <th>Total Cost</th> */}
                                                                                                                                </tr>
                                                                                                                            </thead>
                                                                                                                            <tbody>
                                                                                                                                {agentBillingData && agentBillingData.length > 0 ? (
                                                                                                                                    agentBillingData.map((itemData, index) => {

                                                                                                                                        return (
                                                                                                                                            <tr key={index}>
                                                                                                                                                {/* Agent column (show only once using rowSpan) */}
                                                                                                                                                {index === 0 && (
                                                                                                                                                    <td rowSpan={agentBillingData.length}>
                                                                                                                                                        {/* <FaEnvelope
                                                                                                                                                        style={{ fontSize: "1.8em", color: "#dc3545" }}
                                                                                                                                                        className="mr-2"
                                                                                                                                                    /> */}
                                                                                                                                                        Agent
                                                                                                                                                    </td>
                                                                                                                                                )}

                                                                                                                                                {/* Totals (show only once using rowSpan) */}
                                                                                                                                                {index === 0 && (
                                                                                                                                                    <>
                                                                                                                                                        <td rowSpan={agentBillingData.length}>
                                                                                                                                                            {parseFloat(agentBillingTotalData?.total_paid_amount).toFixed(6) || 0}
                                                                                                                                                        </td>
                                                                                                                                                        <td rowSpan={agentBillingData.length}>
                                                                                                                                                            {agentBillingTotalData?.total_outstanding_amount || 0} {itemData.status === "due" && <button type="button" onClick={() => RechargeAmount(agentBillingData)} className="btn btn-primary">Pay Amount</button>}
                                                                                                                                                        </td>
                                                                                                                                                        <td rowSpan={agentBillingData.length}>
                                                                                                                                                            {agentBillingTotalData?.total_bills || 0}
                                                                                                                                                        </td>
                                                                                                                                                    </>
                                                                                                                                                )}

                                                                                                                                                {/* Row-wise billing data */}
                                                                                                                                                <td>{itemData.billing_type}</td>
                                                                                                                                                <td>{itemData.bill_year}</td>
                                                                                                                                                <td>{Months.find(x => x.value === itemData.bill_month)?.label}</td>
                                                                                                                                                <td>{parseFloat(itemData.paid_amount).toFixed(6)}</td>
                                                                                                                                                <td>{itemData.paid_through}</td>
                                                                                                                                                <td>{itemData.outstanding_amount}</td>
                                                                                                                                                <td>{itemData.status}<span>{itemData.status === "due" && <button type="button" onClick={() => RechargeByID(itemData._id)} className="btn btn-primary">Pay Now</button>}</span></td>
                                                                                                                                                <td>{itemData.paid_date}</td>
                                                                                                                                                <td>{itemData.createdAt}</td>
                                                                                                                                                <td><FontAwesomeIcon style={{ cursor: "pointer" }} onClick={() => agentInnerDetails(itemData.plan)} icon={faEye} /> </td>
                                                                                                                                            </tr>
                                                                                                                                        )
                                                                                                                                    })
                                                                                                                                ) : (
                                                                                                                                    <tr>
                                                                                                                                        <td colSpan="12" className="text-center">
                                                                                                                                            No billing data found
                                                                                                                                        </td>
                                                                                                                                    </tr>
                                                                                                                                )}
                                                                                                                            </tbody>



                                                                                                                        </table>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </td>
                                                                                            </tr>
                                                                                        </React.Fragment>
                                                                                    </tbody>
                                                                                )
                                                                            })}

                                                                    </table>
                                                                </div>


                                                                {totalBillPages > 1 && (
                                                                    <div style={{
                                                                        display: "flex", alignItems: "center", justifyContent: "space-between",
                                                                        flexWrap: "wrap", gap: "10px", marginTop: "12px",
                                                                    }}>
                                                                        <span style={{ fontSize: "13px", color: "#64748b" }}>
                                                                            Showing <b>{(currentPage - 1) * recordsPerPage + 1}</b>–<b>{Math.min(currentPage * recordsPerPage, filteredBillKeys.length)}</b> of <b>{filteredBillKeys.length}</b>
                                                                        </span>
                                                                        <ul className="pagination mb-0">
                                                                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                                <button type="button" className="page-link" onClick={() => setCurrentPage(p => Math.max(1, p - 1))}>
                                                                                    Prev
                                                                                </button>
                                                                            </li>
                                                                            {Array.from({ length: totalBillPages }, (_, i) => i + 1)
                                                                                .filter(p => p === 1 || p === totalBillPages || Math.abs(p - currentPage) <= 1)
                                                                                .reduce((acc, p, idx, arr) => {
                                                                                    if (idx > 0 && p - arr[idx - 1] > 1) acc.push('...');
                                                                                    acc.push(p);
                                                                                    return acc;
                                                                                }, [])
                                                                                .map((p, idx) => (
                                                                                    p === '...' ? (
                                                                                        <li key={`e-${idx}`} className="page-item disabled"><span className="page-link">…</span></li>
                                                                                    ) : (
                                                                                        <li key={p} className={`page-item ${currentPage === p ? 'active' : ''}`}>
                                                                                            <button type="button" className="page-link" onClick={() => setCurrentPage(p)}>
                                                                                                {p}
                                                                                            </button>
                                                                                        </li>
                                                                                    )
                                                                                ))}
                                                                            <li className={`page-item ${currentPage === totalBillPages ? 'disabled' : ''}`}>
                                                                                <button type="button" className="page-link" onClick={() => setCurrentPage(p => Math.min(totalBillPages, p + 1))}>
                                                                                    Next
                                                                                </button>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                )}
                                                            </> :
                                                            <div className="text-center">
                                                                <div className="card-body">
                                                                    <img alt="Empty Data" className="project-empty-img" src={EmptyImg} />
                                                                    <p>No Data Yet</p>
                                                                </div>
                                                            </div>
                                                        }

                                                        {/* {this.state.enitytList && 
                                                                <AdvanceDataTable
                                                                    tableName={""}
                                                                    tableCell={ENTITY_MANAGEMENT_LIST}
                                                                    tableData={this.state.enitytList}
                                                                    pagination={true}
                                                                    EditEntityID={this.EditEntityID}
                                                                    userList = {this.state.allUsers}
                                                                    // isLoading={this.state.setIsLoading}
                                                                    // isError={this.state.ErrorResponse}
                                                                />} */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </AdminLayout >
            {enterOtp &&
                <div
                    className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                    style={{ background: 'rgba(0,0,0,0.5)', zIndex: 1050 }}
                >
                    <div className="bg-white p-4 rounded shadow" style={{ width: '300px' }}>
                        <h5 className="mb-3">Enter OTP</h5>
                        <input
                            type="text"
                            className="form-control mb-3"
                            placeholder="Enter your OTP"
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                        />
                        <div className="d-flex justify-content-end">
                            <button className="btn btn-secondary me-2" onClick={() => setEnterOtp(false)}>Cancel</button>
                            <button className="btn btn-primary" onClick={""}>Submit</button>
                        </div>
                    </div>
                </div>
            }
            {agentDetailsShow &&
                (
                    <div style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "rgba(0,0,0,0.3)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 999
                    }}>

                        <div style={{
                            width: 600,
                            background: "white",
                            borderRadius: 16,
                            padding: 25,
                            position: "relative"
                        }}>

                            {/* Close */}
                            <span
                                onClick={() => setAgentDetailsShow(false)}
                                style={{
                                    position: "absolute",
                                    right: 20,
                                    top: 15,
                                    fontSize: 22,
                                    cursor: "pointer"
                                }}
                            >
                                ✕
                            </span>

                            <h3 style={{ marginBottom: 20 }}>Agent Details</h3>
                            {/* <h4>Billing calculation</h4>

                            <div style={{ marginBottom: 15 }}>
                                <b>Auto renew</b>
                                <div style={{ color: "#777" }}>
                                    Automatically renew subscription
                                </div>
                            </div> */}

                            <hr />

                            <div style={{ lineHeight: "28px" }}>
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <span>Agent Price<span>{`(${totalAgentData.agentPrice})`}</span> x Agent Quantity <span>{`(${totalAgentData.agentQuantity})`}</span></span>
                                    <span style={{ textDecoration: "line-through" }}>{totalAgentData.baseAmount}</span>
                                </div>

                                <div style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    color: "#10B981"
                                }}>
                                    <span>Agent discount {`(${totalAgentData.agentDiscount}%)`}</span>
                                    <span>{`-₹${totalAgentData.agentDiscountAmount}`}</span>
                                </div>

                                <div style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    fontWeight: "600"
                                }}>
                                    <span>Discounted price</span>
                                    <span>{`₹${totalAgentData.baseAmount - totalAgentData.agentDiscountAmount}`}</span>
                                </div>
                            </div>

                            <hr />

                            <div style={{ lineHeight: "28px" }}>
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <span>Yearly Discount</span>
                                    <span>{`₹${totalAgentData.yearlyDiscount}`}</span>
                                </div>

                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <span>Coupon Discount</span>
                                    <span>{`₹${totalAgentData.couponDiscount}`}</span>
                                </div>

                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <span>Per Day</span>
                                    <span>{totalAgentData.pricePerDay}</span>
                                </div>
                            </div>

                            <hr />

                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginTop: 10,
                                color: "#10B981"
                            }}>
                                <span>Total</span>
                                <span>{`₹${parseFloat(totalAgentData.totalDiscountPrice).toFixed(6)}`}</span>
                            </div>

                            {/* <div style={{ marginTop: 15, color: "#666" }}>
                                Renews automatically on <b>1/6/2026</b> at ₹900 /month
                            </div> */}

                        </div>
                    </div>
                )}

            {/* ── BRAND NUMBER SELECT MODAL ── */}
            {brandNumberModal && (
                <div
                    style={{
                        position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
                        background: "rgba(0,0,0,0.5)", display: "flex",
                        justifyContent: "center", alignItems: "center", zIndex: 1100,
                    }}
                >
                    <div style={{
                        background: "white", borderRadius: 12, padding: 24,
                        width: "90%", maxWidth: 420, maxHeight: "85vh",
                        overflowY: "auto", position: "relative",
                    }}>
                        <span
                            onClick={() => setBrandNumberModal(false)}
                            style={{ position: "absolute", right: 18, top: 14, fontSize: 22, cursor: "pointer" }}
                        >✕</span>

                        <h5 className="mb-1">Select Brand Number</h5>
                        <p className="text-muted mb-3" style={{ fontSize: 13 }}>
                            User: <strong>{pendingMetaUser?.username}</strong>
                        </p>

                        {brandNumberLoading ? (
                            <div className="text-center py-4">Loading...</div>
                        ) : brandNumberList.length === 0 ? (
                            <div className="text-center py-4 text-muted">No brand number found</div>
                        ) : (
                            <>
                                <select
                                    className="form-control mb-3"
                                    value={selectedBrandNumber}
                                    onChange={(e) => setSelectedBrandNumber(e.target.value)}
                                >
                                    {brandNumberList.map((item, i) => (
                                        <option key={i} value={item.brand_number}>
                                            {item.brand_number} {item.comp_name ? `(${item.comp_name})` : ''}
                                        </option>
                                    ))}
                                </select>
                                <button
                                    className="btn btn-primary w-100"
                                    onClick={handleBrandNumberContinue}
                                    disabled={!selectedBrandNumber}
                                >
                                    Continue
                                </button>
                            </>
                        )}
                    </div>
                </div>
            )}

            {/* ── META BILLING MODAL ── */}
            {metaBillingModal && (
                <div
                    style={{
                        position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
                        background: "rgba(0,0,0,0.5)", display: "flex",
                        justifyContent: "center", alignItems: "center", zIndex: 1100,
                    }}
                >
                    <div style={{
                        background: "white", borderRadius: 12, padding: 24,
                        width: "90%", maxWidth: 900, maxHeight: "85vh",
                        overflowY: "auto", position: "relative",
                    }}>
                        <span
                            onClick={() => setMetaBillingModal(false)}
                            style={{ position: "absolute", right: 18, top: 14, fontSize: 22, cursor: "pointer" }}
                        >✕</span>

                        <h5 className="mb-1">Meta Billing Details</h5>
                        <p className="text-muted mb-3" style={{ fontSize: 13 }}>
                            User: <strong>{metaBillingUser}</strong> &nbsp;|&nbsp;
                            {fromdate && todate && `${currentDate(fromdate)} → ${currentDate(todate)}`}
                        </p>

                        {metaBillingLoading ? (
                            <div className="text-center py-4">Loading...</div>
                        ) : metaBillingData.length === 0 ? (
                            <div className="text-center py-4 text-muted">No data found</div>
                        ) : (
                            <div className="table-responsive">
                                <table className="table table-striped table-bordered mb-0">
                                    <thead className="bg-secondary text-white">
                                        <tr>
                                            <th style={{ whiteSpace: "nowrap" }}>
                                                From Date
                                            </th>
                                            <th style={{ whiteSpace: "nowrap" }}>
                                                To Date
                                            </th>
                                            <th style={{ whiteSpace: "nowrap" }}>
                                                Sent
                                            </th>
                                            <th style={{ whiteSpace: "nowrap" }}>
                                                Delivered
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {metaBillingData.map((row, i) => {
                                            const fmtUnix = (ts) => {
                                                if (!ts) return "-";
                                                const d = new Date(Number(ts) * 1000);
                                                const day = String(d.getDate()).padStart(2, "0");
                                                const month = String(d.getMonth() + 1).padStart(2, "0");
                                                return `${day}-${month}-${d.getFullYear()}`;
                                            };
                                            return (
                                                <tr key={i}>
                                                    <td>{fmtUnix(row.start)}</td>
                                                    <td>{fmtUnix(row.end)}</td>
                                                    <td>{row.sent ?? "-"}</td>
                                                    <td>{row.delivered ?? "-"}</td>
                                                </tr>
                                            );
                                        })}
                                        <tr style={{ fontWeight: 700, background: "#e8f5e9" }}>
                                            <td colSpan={metaBillingData.length}>
                                                Total Sent:&nbsp;
                                                <strong>
                                                    {metaBillingData.reduce((acc, row) => {
                                                        const key = Object.keys(row).find(k => k.toLowerCase().includes("sent") || k.toLowerCase().includes("total"));
                                                        return acc + (parseFloat(row[key]) || 0);
                                                    }, 0)}
                                                </strong>
                                                &nbsp;&nbsp;|&nbsp;&nbsp;
                                                Total Delivered:&nbsp;
                                                <strong>
                                                    {metaBillingData.reduce((acc, row) => {
                                                        const key = Object.keys(row).find(k => k.toLowerCase().includes("deliver"));
                                                        return acc + (parseFloat(row[key]) || 0);
                                                    }, 0)}
                                                </strong>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div >
    );
};

export default AdminBillingReport;
